import React, { Component } from 'react';
import { connect } from 'react-redux';
import { loadSessionfromSSET, downloadSolutionPreview, sapSolPreview, sapHanaSolPreview, sapTdiSolPreview } from '../../State/actions/sessions';
import queryString from 'query-string'
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import Box from 'grommet/components/Box';
import List from 'grommet/components/List';
import Heading from 'grommet/components/Heading';
import ListItem from 'grommet/components/ListItem';
import Animate from 'grommet/components/Animate';
import Paragraph from 'grommet/components/Paragraph';
import CloseIcon from 'grommet/components/icons/base/FormClose';
import Table from 'grommet/components/Table';
import TableRow from 'grommet/components/TableRow';
import Label from 'grommet/components/Label';
import Button from 'grommet/components/Button';
import Revert from 'grommet/components/icons/base/Revert';
import { said } from '../../AppConfig';
import * as commonConstants from '../../State/constants/CommonConstants';
const INFERENCE_ = "Inference";
const TRAINING = 'Training';
const STORAGE_ = "Storage";
const TRUE = "true";
const NONE_ = "None";
const KUBERNETES_ = "Kubernetes";
const EPIC_ = "EPIC";
const HPE_CP = "HPE Runtime Enterprise";
const HPE_CP_EPIC_SOFTWARE = "HPE Ezmeral Runtime Enterprise EPIC Software";
const HPE_CP_ML_SOFTWARE = "HPE Ezmeral ML Ops Software";
const KUBERNETES_CM = "Kubernetes CM"
const CONTROLLER_HOSTS = "Controller Hosts";
const GATEWAY_HOSTS = "Gateway Hosts";
const MASTER_HOST = "Master Hosts";
const MLOPS = "MLOps";
const CAAS = "CaaS";
const ATTRIBUTE_SOLUTIONTYPE = "@SolutionType";
const NODE_ = 'Ephemeral';
const IMAGE_PROCESSING = "Image Processing";
const MLOPS_TEMPLATES = "MLOps Templates";
const MLOPS_IMAGE_PROCESSING = "MLOps Image Processing";
const IMAGE_PROCESSING_TEMPLATE = "Image Processing Template";
const HPE_E_CP_EXTERNAL_K8S_CLUSTER_MNGR = "HPE Ezmeral RE External Kubernetes Cluster Manager";
const NONGPU_ = "NonGPU";
const EZMERAL_GROWTH_HEADINGS = ['Services', 'Growth', 'Total % of Host Yr 1', 'Total % of Host Yr 2', 'Total % of Host Yr 3', 'Total % of Host Yr 4'];
const GPU_ = "GPU";
let GATEWAY_ = "Gateway";
const CONTROLLER_ = "Controller";
const MASTER_ = "Master";
const HPE_EZMERAL_DF_XD = "HPE Ezmeral Data Fabric XD";
const HPE_EZMERAL_DATAFABRIC_LICENSE = "HPE Ezmeral Data Fabric License";
const DATAFABRIC_XD = "DataFabric XD";
const DATAFABRIC_FILESTORE = "DataFabric File Store";
const HPE_EZMERAL = "HPE Ezmeral ";
const FALSE = "false";
const SOLUTION_PREVIEW = "Solution Preview";
const DATA_LAKE = "Data Lake";
const USABLE_CAPACITY = "Usable capacity ";
const ATTRIBUTE_TYPE = "@Type";
const ATTRIBUTE_INPUTMODE = "@InputMode";
const ATTRIBUTE_CATEGORY = "@Category";
let getSSETData = false;
const CS750SizerSaid = ['CS750VirtSizer', 'SynergySizer'];
const SAPSizerSaid = ['SAP', 'SAPHANA'];
const ID_SOLUTION_PREVIEW = "SolutionPreview";
let tabsList = [];
//let tabHeadings = "";
var labelsTobeBold = ['Recommended', 'Host Configuration', 'Storage Configuration'];

class SolutionPreviewBigData extends Component {

    constructor(props) {
        super(props);
        this.state = {
            DataDiskList: "",
            consolidatedDiskQty: 0
        }
    }

    populateDataDiskList = (service) => {
        this.state.consolidatedDiskQty = 0
        if (Array.isArray(service.DataDisks)) {
            this.state.DataDiskList = []
            service.DataDisks.map((x, id) => {
                this.state.consolidatedDiskQty += parseInt(x.Item["@qty"], 10)
                this.state.DataDiskList.push(
                    <li className='secondary'>{x.Item["@disk"] + " (" + x.Item["@qty"] + ")"}</li>
                )
            })
        }
        else {
            this.state.DataDiskList = service.Hardware['@DataDisk']
            this.state.consolidatedDiskQty = service.Hardware['@DiskQty']
        }

    }

    render() {
        let Hdngwid = '35%'
        let Datawid = '65%'
        let txtalgn = 'left'
        let fntwght = '600'
        let diskcapacityvalue, compression, ensurecodngdata, ensurecodngparity, overhead, strgwrkload, capacitytypevalue, replicationvalue, GrowthContent
        let ARCvalue, Scalitydiskcapacityvalue, GreenLakevalue, Sitesvalue, ScalityPercentage, NetworkSwitch, NoofNetwrkSwitch, ScalityReplication
        let FunctionsScreen = [];
        //let ExtraNodeScreen = [];
        let InfrastructureScrn = '';
        //let Extscrn = '';
        //let Driveclassvalue, SKUvalue, Peakreadbw, Peakwritebw, Peakreadiops, Peakwriteiops, Usablestorage, DIMMcapacity, DATAdrivecapacity, Spareserver, Datadriverperserver, Noofservers
        let Peakreadbw, Peakwritebw, Peakreadiops, Peakwriteiops, Usablestorage, DIMMcapacity, DATAdrivecapacity, Spareserver, Datadriverperserver, Noofservers
        //  let Heading=''
        let HadoopServicesScreen = ''
        //let HadoopHeading = ''
        let LicensingHeading = ''
        //let ServiceHeading = ''
        let HDFSndMapr = '';
        let RepDisplay = "";
        let DataParity =
            this.props.workload.UserInputs.Environments.Functions.Function.map((val) => {
                if (Array.isArray(val.Service)) {
                    val.Service.map((service) => {
                        if (service['@Selected'] === "true") {
                            this.props.workload.UserInputs.Environments.Growth.Service.map(elem => {
                                if (service['@Type'] === elem["@Service"]) {
                                    return GrowthContent = <Box>
                                        <Box direction="row" style={{ display: RepDisplay }}>
                                            <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Growth Rate:</Box>
                                            <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{elem["@GrowthRate"]}</Box>
                                        </Box>
                                        <Box direction="row" style={{ display: RepDisplay }}>
                                            <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Growth Type:</Box>
                                            <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{elem["@GrowthType"]}</Box>
                                        </Box>
                                        <Box direction="row" style={{ display: RepDisplay }}>
                                            <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Nodes Y1:</Box>
                                            <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{elem["@Nodes1Y"]}</Box>
                                        </Box>
                                        <Box direction="row" style={{ display: RepDisplay }}>
                                            <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Nodes Y2:</Box>
                                            <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{elem["@Nodes2Y"]}</Box>
                                        </Box>
                                        <Box direction="row" style={{ display: RepDisplay }}>
                                            <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Nodes Y3:</Box>
                                            <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{elem["@Nodes3Y"]}</Box>
                                        </Box>
                                    </Box>
                                }
                            })
                            if (service['@Type'] === DATA_LAKE || service['@Type'] === "MapR and MapR-EC") {
                                diskcapacityvalue = service.Inputs['@Capacity'];
                                compression = service.Inputs['@Compression'];
                                ensurecodngdata = service.Inputs['@ErasureData'];
                                ensurecodngparity = service.Inputs['@ErasureParity'];
                                overhead = service.Inputs['@OverHead'];
                                strgwrkload = service.Inputs['@StorageWL'];
                                capacitytypevalue = service.Inputs['@Type'];
                                replicationvalue = service.Inputs['@Replication'];
                                // Heading=val['@Type']+":"+"  "+service['@Type']
                                if (service.Inputs['@ErasureCoding'] === "false") {
                                    DataParity = "none"
                                    RepDisplay = "Visible"
                                } else {
                                    DataParity = "Visible"
                                    RepDisplay = "none"
                                }
                                HDFSndMapr = <Box style={{ width: '40%' }}>
                                    <Box direction="row">
                                        <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Disk Capacity:</Box>
                                        <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{diskcapacityvalue}</Box>
                                    </Box>
                                    {capacitytypevalue === USABLE_CAPACITY &&
                                        <Box direction="row">
                                            <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Compression:</Box>
                                            <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{compression}</Box>
                                        </Box>
                                    }
                                    <Box direction="row" style={{ display: DataParity }}>
                                        <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Data:</Box>
                                        <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{ensurecodngdata}</Box>
                                    </Box>
                                    <Box direction="row" style={{ display: DataParity }}>
                                        <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Parity:</Box>
                                        <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{ensurecodngparity}</Box>
                                    </Box>
                                    {capacitytypevalue === USABLE_CAPACITY &&
                                        <Box direction="row">
                                            <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Overhead:</Box>
                                            <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{overhead}</Box>
                                        </Box>
                                    }
                                    <Box direction="row">
                                        <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Capacity:</Box>
                                        <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{capacitytypevalue}</Box>
                                    </Box>
                                    {capacitytypevalue === USABLE_CAPACITY &&
                                        <Box direction="row" style={{ display: RepDisplay }}>
                                            <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Replication:</Box>
                                            <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{replicationvalue}</Box>
                                        </Box>
                                    }
                                    {GrowthContent}

                                </Box>
                            }
                            else if (service['@Type'] === "Scality") {
                                ARCvalue = service.Inputs['@ARC'];
                                Scalitydiskcapacityvalue = service.Inputs['@Capacity'];
                                GreenLakevalue = service.Inputs['@GreenLake'];
                                Sitesvalue = service.Inputs['@NoOfSites'];
                                ScalityReplication = service.Inputs['@Replication'];
                                ScalityPercentage = service.Inputs['@StoragePerc'];
                                NetworkSwitch = service.Inputs['@NwSwitch'];
                                NoofNetwrkSwitch = service.Inputs['@NwSwitchQty'];
                                //Heading=val['@Type']+":"+"  "+service['@Type']
                                HDFSndMapr = <Box style={{ width: '40%' }}>
                                    <Box direction="row">
                                        <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Select Green Lake Flex Capacity:</Box>
                                        <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{GreenLakevalue}</Box>
                                    </Box>
                                    <Box direction="row">
                                        <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>How many sites do you want your primary data stored in ?:</Box>
                                        <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{Sitesvalue}</Box>
                                    </Box>
                                    <Box direction="row">
                                        <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Replication to a second site:</Box>
                                        <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{ScalityReplication}</Box>
                                    </Box>
                                    <Box direction="row">
                                        <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Percent of storage containing ARC encoded objects:</Box>
                                        <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{ScalityPercentage}</Box>
                                    </Box>
                                    <Box direction="row">
                                        <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Disk Capacity:</Box>
                                        <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{Scalitydiskcapacityvalue}</Box>
                                    </Box>
                                    <Box direction="row">
                                        <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>calculated ARC(X,Y) level:</Box>
                                        <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{ARCvalue}</Box>
                                    </Box>
                                    <Box direction="row">
                                        <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Network Switch:</Box>
                                        <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{NetworkSwitch}</Box>
                                    </Box>
                                    <Box direction="row">
                                        <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>No. Of Network Switches :</Box>
                                        <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{NoofNetwrkSwitch}</Box>
                                    </Box>
                                    {GrowthContent}
                                </Box>
                            }
                            else if (val['@Type'] === 'Streaming') {
                                //Heading=val['@Type']+":"+"  "+service['@Type']
                                HDFSndMapr = <Box style={{ width: '40%' }}>
                                    <Box direction="row">
                                        <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Thousands of Message(Message size 250 bytes) :</Box>
                                        <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{service.Inputs['@MessagesPerSec']}</Box>
                                    </Box>
                                    {GrowthContent}
                                </Box>
                            }
                            else if (val['@Type'] === "AI") {
                                // Heading=val['@Type']+":"+"  "+service['@Type']
                                HDFSndMapr = <Box style={{ width: '40%' }}>
                                    <Box direction="row">
                                        <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Processing Images Per Sec:</Box>
                                        <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{service.Inputs['@ImagesPerSec']}</Box>
                                    </Box>
                                    <Box direction="row">
                                        <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Configuration Type :</Box>
                                        <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{service.Inputs['@ConfigType']}</Box>
                                    </Box>
                                    <Box direction="row">
                                        <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>GPUs :</Box>
                                        <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{service.Inputs['@GPU']}</Box>
                                    </Box>
                                    <Box direction="row">
                                        <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>no of GPUs:</Box>
                                        <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{service.Inputs['@GPUQty']}</Box>
                                    </Box>
                                    {GrowthContent}
                                </Box>
                            }
                            else if (val['@Type'] === "IoT") {
                                // Heading=val['@Type']+":"+"  "+service['@Type']

                                HDFSndMapr = <Box style={{ width: '40%' }}>
                                    <Box direction="row">
                                        <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Thousands of Events Per Sec:</Box>
                                        <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{service.Inputs['@EventsPerSec']}</Box>
                                    </Box>
                                </Box>

                            }
                            else if (val['@Type'] === "Analytics") {
                                // var QtyHeading = "Container Qty:"
                                // var CoreHeading = "Cores Per Container:"
                                // var MemoryHeading = "Memory Per Container:"
                                // if (service['@Type'] === "Yarn") {
                                //     if (service.Inputs['@ConfigType'] === "Containers") {
                                //         QtyHeading = "Number of Containers"
                                //     } else {
                                //         QtyHeading = "Number of Storage Nodes"
                                //     }
                                // } else if (service['@Type'] === "Spark") {
                                //     if (service.Inputs['@ConfigType'] === "Executors") {
                                //         QtyHeading = "Number of Executors"
                                //     } else {
                                //         QtyHeading = "Number of Storage Nodes"
                                //     }
                                // }
                                var data = '';
                                if (service['@Type'] === "Yarn" && service.Inputs['@ConfigType'] === "Containers") {

                                    data = <Box Pad={{ between: "small" }}>
                                        <Box direction="row">
                                            <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Number of Containers:</Box>
                                            <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{service.Inputs['@ContainersQty']}</Box>
                                        </Box>
                                        <Box direction="row">
                                            <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Cores Per Container:</Box>
                                            <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{service.Inputs['@CoresPerContainer']}</Box>
                                        </Box>
                                        <Box direction="row">
                                            <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Memory Per Container:</Box>
                                            <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{service.Inputs['@MemoryPerContainer']}</Box>
                                        </Box>
                                    </Box>
                                } else if (service['@Type'] === "Yarn" && service.Inputs['@ConfigType'] === "Storage Ratio") {
                                    data = <Box Pad={{ between: "small" }}>
                                        <Box direction="row">
                                            <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Number of Storage Nodes:</Box>
                                            <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{service.Inputs['@StorageNodesQty']}</Box>
                                        </Box>
                                        <Box direction="row">
                                            <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Storage to Compute Ratio:</Box>
                                            <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{service.Inputs['@SCRatio']}</Box>
                                        </Box>
                                    </Box>
                                }
                                if (service['@Type'] === "Spark" && service.Inputs['@ConfigType'] === "Executors") {

                                    data = <Box Pad={{ between: "small" }}>
                                        <Box direction="row">
                                            <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Number of Executors:</Box>
                                            <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{service.Inputs['@ContainersQty']}</Box>
                                        </Box>
                                        <Box direction="row">
                                            <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Cores Per Executors:</Box>
                                            <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{service.Inputs['@CoresPerContainer']}</Box>
                                        </Box>
                                        <Box direction="row">
                                            <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Memory Per Executors:</Box>
                                            <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{service.Inputs['@MemoryPerContainer']}</Box>
                                        </Box>
                                    </Box>
                                } else if (service['@Type'] === "Spark" && service.Inputs['@ConfigType'] === "Storage Ratio") {
                                    data = <Box Pad={{ between: "small" }}>
                                        <Box direction="row">
                                            <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Number of Storage Nodes:</Box>
                                            <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{service.Inputs['@StorageNodesQty']}</Box>
                                        </Box>
                                        <Box direction="row">
                                            <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Storage to Compute Ratio:</Box>
                                            <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{service.Inputs['@SCRatio']}</Box>
                                        </Box>
                                    </Box>
                                }
                                // Heading=val['@Type']+":"+"  "+service['@Type']
                                HDFSndMapr = <Box Pad={{ between: "small" }} style={{ width: '40%' }}>
                                    <Box direction="row">
                                        <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Configuration Based on:</Box>
                                        <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{service.Inputs['@ConfigType']}</Box>
                                    </Box>
                                    <Box direction="row">
                                        <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Node Local Storage (TB):</Box>
                                        <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{service.Inputs['@NodeStorage']}</Box>
                                    </Box>
                                    {data}
                                    {GrowthContent}
                                    {/* <Box direction="row">
                                        <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Container Qty:</Box>
                                        <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{service.Inputs['@ContainersQty']}</Box>
                                    </Box>
                                    <Box direction="row">
                                        <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Cores Per Container:</Box>
                                        <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{service.Inputs['@CoresPerContainer']}</Box>
                                    </Box>
                                    <Box direction="row">
                                        <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Memory Per Container:</Box>
                                        <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{service.Inputs['@MemoryPerContainer']}</Box>
                                    </Box>
                                    <Box direction="row">
                                        <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Number of Storage Nodes:</Box>
                                        <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{service.Inputs['@StorageNodesQty']}</Box>
                                    </Box>
                                    <Box direction="row">
                                        <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Storage to Compute Ratio:</Box>
                                        <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{service.Inputs['@SCRatio']}</Box>
                                    </Box>*/}
                                </Box>

                            }
                            else if (val['@Type'] === "Database") {
                                //Heading=val['@Type']+":"+"  "+service['@Type']
                                let operatonsname = "Operations per Sec(In Thousands)"
                                if (service['@Type'] === "Hive") {
                                    operatonsname = "Queries Per Minute"
                                }
                                HDFSndMapr = <Box Pad={{ between: "small" }} style={{ width: '40%' }}>
                                    {(service['@Type'] === "Hive" || service['@Type'] === "HBase") ? <Box direction="row">
                                        <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>{operatonsname}:</Box>
                                        <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{service.Inputs['@OpsPerSec']}</Box>
                                    </Box> : ""}
                                    {service['@Type'] === "Hive" ?
                                        <Box direction="row">
                                            <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Database Size (TB):</Box>
                                            <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{service.Inputs['@Capacity']}</Box>
                                        </Box> : ""}
                                    <Box direction="row">
                                        <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Node Local Storage:</Box>
                                        <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{service.Inputs['@NodeStorage']}</Box>
                                    </Box>
                                    {GrowthContent}
                                    {/*<Box direction="row">
                                    <Box style={{ width: Hdngwid, textAlign: txtalgn,fontWeight: fntwght }} className='secondary'>Capacity:</Box>
                                    <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{service.Inputs['@Capacity']}</Box>
                                </Box>*/}
                                </Box>

                            }
                            else if (service['@Type'] === "Weka") {
                                //SKUvalue = service.Inputs['@SKUInfo'];
                                //Driveclassvalue = service.Inputs['@DriveClass'];
                                Peakreadbw = service.Inputs['@PeakReadBW'];
                                Peakwritebw = service.Inputs['@PeakWriteBW'];
                                Peakreadiops = service.Inputs['@PeakReadIOPS'];
                                Peakwriteiops = service.Inputs['@PeakWriteIOPS'];
                                Usablestorage = service.Inputs['@Capacity'];
                                DIMMcapacity = service.Inputs['@DIMMCapacity'];
                                DATAdrivecapacity = service.Inputs['@DATADriveCapacity'];
                                Spareserver = service.Inputs['@SpareServers'];
                                Datadriverperserver = service.Inputs['@DATADrivePerServer'];
                                Noofservers = service.Hardware['@NodesCount'];
                                let Wekaforall = ''
                                Wekaforall = <Box>
                                    <Box direction="row">
                                        <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Do you expect to add servers to this deployment?:</Box>
                                        <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{service.Inputs['@AddServers']}</Box>
                                    </Box>
                                    <Box direction="row">
                                        <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Select how you will specify BOM and SKU information:</Box>
                                        <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{service.Inputs['@SKUInfo']}</Box>
                                    </Box>
                                    <Box direction="row">
                                        <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>OS Environment:</Box>
                                        <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{service.Inputs['@OS']}</Box>
                                    </Box>
                                    <Box direction="row">
                                        <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Support Year Count:</Box>
                                        <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{service.Inputs['@SupportYears']}</Box>
                                    </Box>
                                    <Box direction="row">
                                        <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Is Edu/Govern Customer:</Box>
                                        <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{service.Inputs['@IsEduCustomer']}</Box>
                                    </Box>
                                    <Box direction="row">
                                        <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Network Type:</Box>
                                        <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{service.Inputs['@NetworkType']}</Box>
                                    </Box>
                                    <Box direction="row">
                                        <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Tiering Capacity Required:</Box>
                                        <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{service.Inputs['@TierCapacity']}</Box>
                                    </Box>
                                </Box>
                                if (service.Inputs['@SKUInfo'] == 'Customer Requirements' & service.Inputs['@DriveClass'] == 'Mixed Use') {
                                    HDFSndMapr = <Box style={{ width: '40%' }}>
                                        {Wekaforall}
                                        <Box direction="row">
                                            <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Peak Read IOPS(Millions):</Box>
                                            <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{Peakreadiops}</Box>
                                        </Box>
                                        <Box direction="row">
                                            <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Peak Write IOPS(Millions):</Box>
                                            <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{Peakwriteiops}</Box>
                                        </Box>
                                        <Box direction="row">
                                            <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Total Usable Storage(Terabytes):</Box>
                                            <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{Usablestorage}</Box>
                                        </Box>
                                        <Box direction="row">
                                            <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Peak Read Bandwidth(GB/s):</Box>
                                            <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{Peakreadbw}</Box>
                                        </Box>
                                        <Box direction="row">
                                            <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Peak Write Bandwidth(GB/s):</Box>
                                            <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{Peakwritebw}</Box>
                                        </Box>
                                        {GrowthContent}
                                    </Box>
                                }
                                else if (service.Inputs['@SKUInfo'] == 'Customer Requirements' & service.Inputs['@DriveClass'] == 'Read Intensive') {
                                    HDFSndMapr = <Box style={{ width: '40%' }}>
                                        {Wekaforall}
                                        <Box direction="row">
                                            <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Total Usable Storage(Terabytes):</Box>
                                            <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{Usablestorage}</Box>
                                        </Box>
                                        <Box direction="row">
                                            <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Peak Read Bandwidth(GB/s):</Box>
                                            <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{Peakreadbw}</Box>
                                        </Box>
                                        <Box direction="row">
                                            <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Peak Read IOPS(Millions):</Box>
                                            <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{Peakreadiops}</Box>
                                        </Box>

                                    </Box>
                                }
                                else if (service.Inputs['@SKUInfo'] == 'Predefined Configuration' & service.Inputs['@DriveClass'] == 'Read Intensive') {
                                    HDFSndMapr = <Box style={{ width: '40%' }}>
                                        {Wekaforall}
                                        <Box direction="row">
                                            <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>DIMM Capacity(GB):</Box>
                                            <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{DIMMcapacity}</Box>
                                        </Box>

                                        <Box direction="row">
                                            <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>DATA Drive Capacity(TB):</Box>
                                            <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{DATAdrivecapacity}</Box>
                                        </Box>
                                        <Box direction="row">
                                            <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Spare Servers:</Box>
                                            <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{Spareserver}</Box>
                                        </Box>
                                        <Box direction="row">
                                            <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>DATA Drive Per Server:</Box>
                                            <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{Datadriverperserver}</Box>
                                        </Box>
                                        <Box direction="row">
                                            <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Number of Servers:</Box>
                                            <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{Noofservers}</Box>
                                        </Box>

                                    </Box>
                                }
                                else if (service.Inputs['@SKUInfo'] == 'Predefined Configuration' & service.Inputs['@DriveClass'] == 'Mixed Use') {
                                    HDFSndMapr = <Box style={{ width: '40%' }}>
                                        {Wekaforall}
                                        <Box direction="row">
                                            <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>DIMM Capacity(GB):</Box>
                                            <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{DIMMcapacity}</Box>
                                        </Box>

                                        <Box direction="row">
                                            <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>DATA Drive Capacity(TB):</Box>
                                            <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{DATAdrivecapacity}</Box>
                                        </Box>
                                        <Box direction="row">
                                            <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Spare Servers:</Box>
                                            <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{Spareserver}</Box>
                                        </Box>
                                        <Box direction="row">
                                            <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>DATA Drive Per Server:</Box>
                                            <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{Datadriverperserver}</Box>
                                        </Box>
                                        <Box direction="row">
                                            <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Number of Servers:</Box>
                                            <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{Noofservers}</Box>
                                        </Box>

                                    </Box>
                                }
                            }
                            let notforweka = ''
                            this.populateDataDiskList(service)

                            if (service['@Type'] !== "Weka") {
                                notforweka = <Box Pad={{ between: "small" }}>
                                    <Box direction="row">
                                        <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>DataDisk:</Box>
                                        <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{this.state.DataDiskList}</Box>
                                    </Box>
                                    <Box direction="row">
                                        <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>OSDisk:</Box>
                                        <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{service.Hardware['@OSDisk']}</Box>
                                    </Box>
                                </Box>
                            }
                            FunctionsScreen.push(<Box direction='row' style={{ width: '100%' }}>
                                <List style={{ width: '100%' }}>
                                    <ListItem direction="column" separator='horizontal'>
                                        <span style={{ fontWeight: '600' }}>{val['@Type'] + ":  " + service['@Type']}</span>
                                        <Box direction='row' Pad={{ between: "small" }} style={{ width: '100%' }}>
                                            <Box Pad={{ between: "small" }} style={{ width: '60%' }}>
                                                <Box direction="row">
                                                    <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Server:</Box>
                                                    <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{service.Hardware['@Server']}</Box>
                                                </Box>
                                                <Box direction="row">
                                                    <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Processor:</Box>
                                                    <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{service.Hardware['@Proc']}</Box>
                                                </Box>
                                                <Box direction="row">
                                                    <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Processor Quantity:</Box>
                                                    <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{service.Hardware['@ProcQty']}</Box>
                                                </Box>
                                                {/*<Box direction="row">
                                                    <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>DataDisk:</Box>
                                                   <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{service.Hardware['@DataDisk']}</Box>
                                               </Box>
                                              <Box direction="row">
                                                   <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>OSDisk:</Box>
                                                  <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{service.Hardware['@OSDisk']}</Box>
                                             </Box>*/}
                                                {notforweka}
                                                <Box direction="row">
                                                    <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>No. of DataDisk Quantity:</Box>
                                                    <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{this.state.consolidatedDiskQty}</Box>
                                                </Box>
                                                <Box direction="row">
                                                    <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>No. of OSDisk Quantity:</Box>
                                                    <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{service.Hardware['@OSDiskQty']}</Box>
                                                </Box>
                                                <Box direction="row">
                                                    <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Memory:</Box>
                                                    <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{service.Hardware['@Memory']}</Box>
                                                </Box>
                                                <Box direction="row">
                                                    <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Nodes Count:</Box>
                                                    <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{service.Hardware['@NodesCount']}</Box>
                                                </Box>
                                            </Box>
                                            {HDFSndMapr}

                                        </Box>
                                    </ListItem>
                                </List>
                            </Box>)
                        }

                    })
                }
                else {
                    this.props.workload.UserInputs.Environments.Growth.Service.map(elem => {
                        if (val['@Type'] === elem["@Name"]) {
                            return GrowthContent = <Box>
                                <Box direction="row" style={{ display: RepDisplay }}>
                                    <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Growth Rate:</Box>
                                    <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{elem["@GrowthRate"]}</Box>
                                </Box>
                                <Box direction="row" style={{ display: RepDisplay }}>
                                    <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Growth Type:</Box>
                                    <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{elem["@GrowthType"]}</Box>
                                </Box>
                                <Box direction="row" style={{ display: RepDisplay }}>
                                    <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Nodes Y1:</Box>
                                    <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{elem["@Nodes1Y"]}</Box>
                                </Box>
                                <Box direction="row" style={{ display: RepDisplay }}>
                                    <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Nodes Y2:</Box>
                                    <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{elem["@Nodes2Y"]}</Box>
                                </Box>
                                <Box direction="row" style={{ display: RepDisplay }}>
                                    <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Nodes Y3:</Box>
                                    <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{elem["@Nodes3Y"]}</Box>
                                </Box>
                            </Box>
                        }
                    })
                    if (val.Service['@Selected'] === 'true') {
                        if (val.Service['@Type'] === "MiNifi") {
                            // Heading=val['@Type']+":"+"  "+val.Service['@Type']
                            HDFSndMapr = <Box style={{ width: '40%' }}>
                                <Box direction="row">
                                    <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Events Per Sec:</Box>
                                    <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{val.Service.Inputs['@EventsPerSec']}</Box>
                                </Box>
                            </Box>
                        }
                        if (val['@Type'] === "Gateway Node") {
                            //  Heading="Gateway Node"
                            HDFSndMapr = "";
                            if (isNaN(val.Service.Hardware['@NodesCount'])) {
                                GrowthContent = '';
                            }
                        }
                        if (val['@Type'] === "Edge Node") {
                            // Heading="Edge Node"
                            HDFSndMapr = ""
                        }
                        if (val['@Type'] === "Master Node") {
                            // Heading="Master Node"
                            HDFSndMapr = ""
                        }
                        this.populateDataDiskList(val.Service);
                        FunctionsScreen.push(<Box direction='row' style={{ width: '100%' }}>
                            <List style={{ width: '100%' }}>
                                <ListItem direction="column" separator='horizontal'>
                                    <span style={{ fontWeight: '600' }}>{val['@Type']}</span>
                                    <Box direction='row' Pad={{ between: "small" }} style={{ width: '100%' }}>
                                        <Box Pad={{ between: "small" }} style={{ width: '90%' }}>
                                            <Box direction="row">
                                                <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Server:</Box>
                                                <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{val.Service.Hardware['@Server']}</Box>
                                            </Box>
                                            <Box direction="row">
                                                <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Processor:</Box>
                                                <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{val.Service.Hardware['@Proc']}</Box>
                                            </Box>
                                            <Box direction="row">
                                                <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Processor Quantity:</Box>
                                                <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{val.Service.Hardware['@ProcQty']}</Box>
                                            </Box>
                                            <Box direction="row">
                                                <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>DataDisk:</Box>
                                                <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{this.state.DataDiskList}</Box>
                                            </Box>
                                            <Box direction="row">
                                                <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>OSDisk:</Box>
                                                <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{val.Service.Hardware['@OSDisk']}</Box>
                                            </Box>
                                            <Box direction="row">
                                                <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>No. of DataDisk Quantity:</Box>
                                                <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{this.state.consolidatedDiskQty}</Box>
                                            </Box>
                                            <Box direction="row">
                                                <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>No. of OSDisk Quantity:</Box>
                                                <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{val.Service.Hardware['@OSDiskQty']}</Box>
                                            </Box>
                                            <Box direction="row">
                                                <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Memory:</Box>
                                                <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{val.Service.Hardware['@Memory']}</Box>
                                            </Box>
                                            <Box direction="row">
                                                <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Nodes Count:</Box>
                                                <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{val.Service.Hardware['@NodesCount']}</Box>
                                            </Box>
                                        </Box>
                                        <Box Pad={{ between: "small" }} style={{ width: '60%' }}>
                                            {HDFSndMapr}
                                            {GrowthContent}
                                        </Box>

                                    </Box>
                                </ListItem>
                            </List>
                        </Box>)

                    }
                }
            })

        // if (this.props.workload.UserInputs.Environments.HadoopServices['HPCM'] !== 'None' || this.props.workload.UserInputs.Environments.HadoopServices['HWSupport'] !== 'None' || this.props.workload.UserInputs.Environments.HadoopServices['HadoopLicense'] !== 'None' || this.props.workload.UserInputs.Environments.HadoopServices['LinuxLicense'] !== 'None' || this.props.workload.UserInputs.Environments.HadoopServices['iLoLicense'] !== 'None' || this.props.workload.UserInputs.Environments.HadoopServices['Weka'] !== 'None' || this.props.workload.UserInputs.Environments.HadoopServices['Scality'] !== 'None' || this.props.workload.UserInputs.Environments.HadoopServices.Services['@BlueData'] !== 'false' || this.props.workload.UserInputs.Environments.HadoopServices.Services['@ClouderaDSE'] !== 'false' || this.props.workload.UserInputs.Environments.HadoopServices.Services['@HWEnt'] !== 'false' || this.props.workload.UserInputs.Environments.HadoopServices.Services['@ClouderaDW'] !== 'false' || this.props.workload.UserInputs.Environments.HadoopServices.Services['@ClouderaEntDH'] !== 'false' || this.props.workload.UserInputs.Environments.HadoopServices.Services['@ClouderaEntDH'] !== 'false' || this.props.workload.UserInputs.Environments.HadoopServices.Services['@ClouderaODB'] !== 'false' || this.props.workload.UserInputs.Environments.HadoopServices.Services['@HWEntPlus'] !== 'false') {
        //     HadoopHeading = "Licenses and Support"
        //     LicensingHeading = 'Licensing'
        //     if (this.props.workload.UserInputs.Environments.HadoopServices.Services['@ClouderaDSE'] !== 'false' || this.props.workload.UserInputs.Environments.HadoopServices.Services['@ClouderaEntDH'] !== 'false' || this.props.workload.UserInputs.Environments.HadoopServices.Services['@HWEntPlus'] !== 'false' || this.props.workload.UserInputs.Environments.HadoopServices.Services['@BlueData'] !== 'false' || this.props.workload.UserInputs.Environments.HadoopServices.Services['@ClouderaDW'] !== 'false' || this.props.workload.UserInputs.Environments.HadoopServices.Services['@ClouderaEss'] !== 'false' || this.props.workload.UserInputs.Environments.HadoopServices.Services['@HWEnt'] !== 'false')
        //         ServiceHeading = 'Services'

        // }

        // if(this.props.workload.UserInputs.Environments.HadoopServices['HPCM'] !== 'None' || this.props.workload.UserInputs.Environments.HadoopServices['HWSupport'] !== 'None'|| this.props.workload.UserInputs.Environments.HadoopServices['HadoopLicense'] !== 'None'||this.props.workload.UserInputs.Environments.HadoopServices['LinuxLicense'] !== 'None'||this.props.workload.UserInputs.Environments.HadoopServices['Scality'] !== 'None'||this.props.workload.UserInputs.Environments.HadoopServices['Weka'] !== 'None'||this.props.workload.UserInputs.Environments.HadoopServices['iLoLicense'] !== 'None'||this.props.workload.UserInputs.Environments.HadoopServices['HPCM'] !== 'None')
        // {
        //     LicensingHeading = 'Licensing'
        // }

        var Services = []
        //    HadoopHeading=this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Cloudera['@IsSelected'] !=='false' ? "Cloudera":"Hortonworks"
        //    if(HadoopHeading==='Cloudera')
        //    {
        //     this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Cloudera.License.map((name)=>{
        //           if(name['@IsSelected']==='true')
        //            {
        //     Services.push(<Box direction='row' pad={{ between: "small" }}>
        //                 <span>{name['@Type']} :</span>
        //                  <span>{name['@Description']}</span>
        //     </Box>)
        //            }
        //        })

        //    }else{
        //        this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Hortonworks.License.map((name)=>{
        //           if(name['@IsSelected']==='true')
        //            {
        //        Services.push(<Box direction='row' pad={{ between: "small" }}>
        //                 <span>{name['@Type']} :</span>
        //                  <span>{name['@Description']}</span>
        //        </Box>)
        //            }
        //        })
        //    }
        if (this.props.workload.UserInputs.Environments.HadoopServices !== undefined) {
            if (this.props.workload.UserInputs.Environments.HadoopServices.Deployment === undefined) {
                this.props.workload.UserInputs.Environments.HadoopServices.Deployment = 'false';
            }
            if (this.props.workload.UserInputs.Environments.HadoopServices.AppStore === undefined) {
                this.props.workload.UserInputs.Environments.HadoopServices.AppStore = 'false';
            }
            if (this.props.workload.UserInputs.Environments.HadoopServices.Installation === undefined) {
                this.props.workload.UserInputs.Environments.HadoopServices.Installation = 'false';
            }
            if (this.props.workload.UserInputs.Environments.HadoopServices.SingleImage === undefined) {
                this.props.workload.UserInputs.Environments.HadoopServices.SingleImage = {
                    "@Qty": "1",
                    "#text": "false"
                }
            }
            if (this.props.workload.UserInputs.Environments.HadoopServices.CustomImage === undefined) {
                this.props.workload.UserInputs.Environments.HadoopServices.CustomImage = {
                    "@Qty": "1",
                    "#text": "false"
                }
            }
        }
        if (this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses !== undefined) {
            let isDataFabricSelected = false;
            if (this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Cloudera['@IsSelected'] !== 'false' && this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Hortonworks['@IsSelected'] === 'false') {

                this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Cloudera.License.map((name) => {
                    if (name['@IsSelected'] === 'true') {
                        //HadoopHeading = "Cloudera";
                        Services.push(<Box direction='row' pad={{ between: "small" }}>
                            <span style={{ width: Datawid, textAlign: txtalgn, fontWeight: fntwght }}>{name['@Type']} :</span>
                            <span style={{ width: Hdngwid, textAlign: txtalgn }}>{name['@Description']}</span>
                        </Box>)
                    }
                })

            }
            else if (this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Cloudera['@IsSelected'] === 'false' && this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Hortonworks['@IsSelected'] !== 'false') {

                this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Hortonworks.License.map((name) => {
                    if (name['@IsSelected'] === 'true') {
                        //HadoopHeading = "Hortonworks";
                        Services.push(<Box direction='row' pad={{ between: "small" }}>
                            <span style={{ width: Datawid, textAlign: txtalgn, fontWeight: fntwght }}>{name['@Type']} :</span>
                            <span style={{ width: Hdngwid, textAlign: txtalgn }}>{name['@Description']}</span>
                        </Box>)
                    }
                })
            }
            else if (this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.DataFabric !== undefined) {

                if (this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.DataFabric['@IsSelected'] === 'true') {
                    isDataFabricSelected = true;
                    this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.DataFabric.License.map((name) => {
                        if (name['@IsSelected'] === 'true') {
                            //HadoopHeading = "MapR";
                            let serviceName = name['@Type']
                            if (serviceName === DATAFABRIC_XD) {
                                serviceName = DATAFABRIC_FILESTORE;
                            }
                            Services.push(<Box direction='row' pad={{ between: "small" }}>
                                <span style={{ width: Datawid, textAlign: txtalgn, fontWeight: fntwght }}>{HPE_EZMERAL + serviceName}</span>
                                {/*<span style={{ width: Hdngwid, textAlign: txtalgn }}>{name['@Description']}</span>*/}
                            </Box>)
                        }
                    })
                }
            }

            // if (this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License['@IsSelected'] === 'true' && this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License['@Description'] !== 'None') {
            //     let text = "BlueData EPIC Software"
            //     if (this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License['@Type'] !== "BlueData") {
            //         text = this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License['@Type']
            //     }
            //     Services.push(<Box direction='row' pad={{ between: "small" }}>
            //         <span style={{ width: Datawid, textAlign: txtalgn, fontWeight: fntwght }}>{text} :</span>
            //         <span style={{ width: Hdngwid, textAlign: txtalgn }}>{this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License['@Description']}</span>
            //     </Box>)
            // }
            if (Array.isArray(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License)) {
                this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License.map((software) => {
                    let text = ""
                    let includeLicense = true;
                    if (software['@Description'] !== 'None') {
                        if (software['@Type'] === HPE_CP) {
                            text = HPE_CP_EPIC_SOFTWARE
                        } else if (software['@Type'] === "BlueDataAI") {
                            text = HPE_CP_ML_SOFTWARE
                        } else if (software["@Type"] === HPE_EZMERAL_DF_XD) {
                            text = HPE_EZMERAL_DATAFABRIC_LICENSE;
                            includeLicense = isDataFabricSelected;
                        }
                        if (includeLicense) {
                            Services.push(<Box direction='row' pad={{ between: "small" }}>
                                <span style={{ width: Datawid, textAlign: txtalgn, fontWeight: fntwght }}>{text} :</span>
                                <span style={{ width: Datawid, textAlign: txtalgn }} >{software['@Description']}</span>
                            </Box>)
                        }
                    }

                })
            }
        }
        HadoopServicesScreen = <Box pad={{ between: "small" }} style={{ width: '100%', padding: '20px' }}>
            <span style={{ textAlign: "center", fontWeight: fntwght }}>Licenses and Support</span>
            <Box direction='row' pad={{ between: "small" }}>
                <Box pad={{ between: "small" }} style={{ width: '50%' }} >
                    {/* <span style={{fontWeight: fntwght }}>{HadoopHeading}</span>*/}
                    {Services}
                </Box>
                <Box pad={{ between: "small" }} style={{ width: '50%' }} >
                    <span >{LicensingHeading}</span>
                    {this.props.workload.UserInputs.Environments.HadoopServices['HPCM'] !== 'None' ? <span><Box direction="row">
                        <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>HPCM :</Box>
                        <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{this.props.workload.UserInputs.Environments.HadoopServices['HPCM']}</Box>
                    </Box></span> : ''}
                    {this.props.workload.UserInputs.Environments.HadoopServices['HWSupport'] !== 'None' ? <span><Box direction="row">
                        <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>HWSupport :</Box>
                        <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{this.props.workload.UserInputs.Environments.HadoopServices['HWSupport']}</Box>
                    </Box></span> : ''}
                    {this.props.workload.UserInputs.Environments.HadoopServices['HadoopLicense'] !== 'None' ? <span><Box direction="row">
                        <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>HadoopLicense :</Box>
                        <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{this.props.workload.UserInputs.Environments.HadoopServices['HadoopLicense']}</Box>
                    </Box></span> : ''}
                    {this.props.workload.UserInputs.Environments.HadoopServices['LinuxLicense'] !== 'None' ? <span><Box direction="row">
                        <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>LinuxLicense :</Box>
                        <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{this.props.workload.UserInputs.Environments.HadoopServices['LinuxLicense']}</Box>
                    </Box></span> : ''}
                    {/*{this.props.workload.UserInputs.Environments.HadoopServices['MapR'] !== 'None' ? <span><Box direction="row">
                        <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>MapR :</Box>
                        <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{this.props.workload.UserInputs.Environments.HadoopServices['MapR']}</Box>
                    </Box></span> : ''}*/}
                    {this.props.workload.UserInputs.Environments.HadoopServices['Scality'] !== 'None' ? <span><Box direction="row">
                        <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Scality :</Box>
                        <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{this.props.workload.UserInputs.Environments.HadoopServices['Scality']}</Box>
                    </Box></span> : ''}
                    {this.props.workload.UserInputs.Environments.HadoopServices['Weka'] !== 'None' ? <span><Box direction="row">
                        <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Weka :</Box>
                        <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{this.props.workload.UserInputs.Environments.HadoopServices['Weka']}</Box>
                    </Box></span> : ''}
                    {this.props.workload.UserInputs.Environments.HadoopServices['iLoLicense'] !== 'None' ? <span><Box direction="row">
                        <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>iLoLicense :</Box>
                        <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{this.props.workload.UserInputs.Environments.HadoopServices['iLoLicense']}</Box>
                    </Box></span> : ''}
                    {this.props.workload.UserInputs.Environments.HadoopServices['AppStore'] !== 'false' ? <span><Box direction="row">
                        <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>HPE CP App Store Development SVC</Box>
                        <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{this.props.workload.UserInputs.Environments.HadoopServices['AppStore']}</Box>
                    </Box></span> : ''}
                    {this.props.workload.UserInputs.Environments.HadoopServices['Deployment'] !== 'false' ? <span><Box direction="row">
                        <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>HPE CP Deployment and Integration Services :</Box>
                        <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{this.props.workload.UserInputs.Environments.HadoopServices['Deployment']}</Box>
                    </Box></span> : ''}
                    {this.props.workload.UserInputs.Environments.HadoopServices['Installation'] !== 'false' ? <span><Box direction="row">
                        <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Installation and Start-up Services :</Box>
                        <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{this.props.workload.UserInputs.Environments.HadoopServices['Installation']}</Box>
                    </Box></span> : ''}
                    {this.props.workload.UserInputs.Environments.HadoopServices.CustomImage !== undefined ?
                        this.props.workload.UserInputs.Environments.HadoopServices.CustomImage['#text'] !== 'false' ? <span><Box direction="row">
                            <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>HPE CP Custom Image Development SVC :</Box>
                            <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{this.props.workload.UserInputs.Environments.HadoopServices.CustomImage['@Qty']}</Box>
                        </Box></span> : ''
                        : ''}
                    {this.props.workload.UserInputs.Environments.HadoopServices.SingleImage !== undefined ?
                        this.props.workload.UserInputs.Environments.HadoopServices.SingleImage['#text'] !== 'false' ? <span><Box direction="row">
                            <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>HPE CP Single Image Development SVC :</Box>
                            <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{this.props.workload.UserInputs.Environments.HadoopServices.SingleImage['@Qty']}</Box>
                        </Box></span> : ''
                        : ''}
                </Box>
            </Box>

        </Box>

        //ExtraNodes Screen
        //  this.props.workload.UserInputs.Environments.Functions.Function.map((val) => {
        //         if(val.Service['@Selected']==='true')
        //         {
        //             if(val.Service['@Type']==="MiNifi")
        //             {
        //             Extscrn = <Box style={{ width: '40%' }}>
        //                             <Box direction="row">
        //                                 <Box style={{ width: Hdngwid, textAlign: txtalgn,fontWeight: fntwght }} className='secondary'>Events Per Sec:</Box>
        //                                 <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{val.Service.Inputs['@EventsPerSec']}</Box>
        //                             </Box>
        //                       </Box>         
        //             }
        //              ExtraNodeScreen.push(Extscrn)
        //         }
        //let HPCM=this.props.workload.UserInputs.Environments.HadoopServices['HPCM'];
        //InfraStructure Screen
        InfrastructureScrn = <Box direction='row' style={{ width: '100%' }}>
            <List style={{ width: '100%' }}>
                <ListItem direction="column" separator='horizontal'>
                    <span style={{ fontWeight: '600' }}>Infrastructure</span>
                    <Box direction='row' Pad={{ between: "small" }} style={{ width: '100%' }}>
                        <Box Pad={{ between: "small" }} style={{ width: '50%' }}>
                            <Box direction="row">
                                <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Provision Type:</Box>
                                <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{this.props.workload.UserInputs.Environments.Licenses.ProvisionType}</Box>
                            </Box>
                            <Box direction="row">
                                <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Network Speed:</Box>
                                <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{this.props.workload.UserInputs.Environments.Licenses.NetworkSpeed}</Box>
                            </Box>
                            <Box direction="row">
                                <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Network Switch:</Box>
                                <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{this.props.workload.UserInputs.Environments.Licenses.NetworkSwitch}</Box>
                            </Box>
                            {this.props.workload.UserInputs.Environments.Licenses.AdditionalSwitch !== undefined ? <Box direction="row">
                                <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Additional Network Switch:</Box>
                                <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{this.props.workload.UserInputs.Environments.Licenses.AdditionalSwitch['#text']}</Box>
                            </Box> : ''}
                            {/* Added this.props.workload.UserInputs.Environments.Licenses.AdditionalSwitch["#text"] !== "None" for hiding nummber of network switches when None is selected.*/}
                            {this.props.workload.UserInputs.Environments.Licenses.AdditionalSwitch !== undefined && this.props.workload.UserInputs.Environments.Licenses.AdditionalSwitch["#text"] !== "None" ? <Box direction="row">
                                <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Number of Switches:</Box>
                                <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{this.props.workload.UserInputs.Environments.Licenses.AdditionalSwitch["@Qty"]}</Box>
                            </Box> : ''}
                            <Box direction="row">
                                <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Factory Express:</Box>
                                <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{this.props.workload.UserInputs.Environments.Licenses.FactoryExpress}</Box>
                            </Box>
                        </Box>
                        <Box Pad={{ between: "small" }} style={{ width: '50%' }}>
                            <Box direction="row">
                                <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Max Power:</Box>
                                <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{this.props.workload.UserInputs.Environments.Licenses.MaxPower}</Box>
                            </Box>
                            <Box direction="row">
                                <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Max Weight:</Box>
                                <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{this.props.workload.UserInputs.Environments.Licenses.MaxWeight}</Box>
                            </Box>
                            <Box direction="row">
                                <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Rack:</Box>
                                <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{this.props.workload.UserInputs.Environments.Licenses.Rack}</Box>
                            </Box>
                            <Box direction="row">
                                <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Rack Description:</Box>
                                <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{this.props.workload.UserInputs.Environments.Licenses.RackDescription}</Box>
                            </Box>
                        </Box>
                    </Box>
                </ListItem>
            </List>
        </Box>

        return (
            <Box>
                {FunctionsScreen}
                {HadoopServicesScreen}
                {InfrastructureScrn}
            </Box>
        )
    }
}

class SolutionPreviewBlue extends Component {

    constructor() {
        super();
        this.state = {
            tenantDriveList: '',
            consolidatedTenantDriveQty: 0
        }
        this.validateServer = this.validateServer.bind(this);
    }

    populateTenantDriveList = (role) => {
        this.state.tenantDriveList = '';
        this.state.consolidatedTenantDriveQty = 0
        if (Array.isArray(role.PersistentDisks) && role["@mixedTenantStorage"] === "True") {
            this.state.tenantDriveList = []
            role.PersistentDisks.map((x) => {
                this.state.consolidatedTenantDriveQty += parseInt(x.Item["@qty"], 10)
                this.state.tenantDriveList.push(
                    <Paragraph>{x.Item["@disk"] + " (" + x.Item["@qty"] + ")"}</Paragraph>
                )
            })
        }
        else {
            this.state.tenantDriveList = role['@TStorageDrive'];
            this.state.consolidatedTenantDriveQty = role['@TStorageDriveQty'];
        }
    }
    validateServer(item, selectedSolution, imageProcessing) {
        var temp = false;

        if (item['@Type'] === GPU_) {
            var sum = 0;
            selectedSolution.Templates.Template.map((x, id) => {
                sum += parseInt(x.Nodes["@GPUs"], 10);
            });
            if ((sum > -1 || imageProcessing) && selectedSolution.GPUValue.isCalculated === TRUE) {
                temp = true;
            } else {
                temp = false
            }
        }
        else if (item['@Type'] === "NonGPU") {
            if (selectedSolution.Templates.Template.filter(x => x["@Type"].indexOf(INFERENCE_) > -1).length > 0 && selectedSolution.Templates.Template.filter(x => (x["@Type"].indexOf('GPU') !== -1 && x["@Type"].indexOf(INFERENCE_) === -1)).length > 0) {
                if (selectedSolution.NonGPUValue.isCalculated === TRUE) {
                    temp = true;
                }
            }
            selectedSolution.Templates.Template.map((x, id) => {
                if (x["@Type"] !== 'None' && x.Nodes["@vClusters"].toString() !== '0' && x.Nodes["@vNodesPerCluster"].toString() !== '0' && x.Nodes["@GPUs"].toString() === '0' && !temp) {
                    if (selectedSolution.NonGPUValue.isCalculated === TRUE) {
                        temp = true;
                    }
                }
            });
            if (parseInt(item["@NodesCount"], 10) > 0 && selectedSolution.NonGPUValue.isCalculated === TRUE) {
                temp = true;
            }

        } else if (item["@Type"] === STORAGE_) {
            if (selectedSolution.StorageValue.isCalculated === TRUE) {
                temp = true;
            }
        }

        return temp;
    }

    renderMainScreenandManagementHosts = () => {
        let mainScreenandManagementHosts = [];
        const createRole = (item, selectedSolution) => {
            let text = CONTROLLER_HOSTS;
            let GPUtext = ''
            let totalgpustext = ''
            let tenantstorage = ''
            let tenantstorageqty = ''
            let VMWareCheckBox = ''
            let Soldisplay = ''
            let driveType = NODE_;
            if (selectedSolution) {
                text = item['@RoleName'];
                if (item['@Type'] === NONGPU_) {
                    Soldisplay = "";
                    if (selectedSolution.Templates.Template.filter(x => x[ATTRIBUTE_TYPE].indexOf(INFERENCE_) > -1).length > 0) {
                        totalgpustext = <TableRow><td>GPU Type:</td> <td>{item['@GPUType']}</td> </TableRow>
                    }
                }
                if (item['@Type'] === GPU_) {
                    Soldisplay = ""
                    if (selectedSolution.Templates.Template.filter(x => x["@Type"] !== INFERENCE_ && x["@Type"].indexOf(INFERENCE_) > -1).length >= selectedSolution.Templates.Template.length - 1) {
                        text = INFERENCE_;
                    }
                    GPUtext = <TableRow><td>GPU Type:</td> <td>{item['@GPUType']}</td> </TableRow>

                    totalgpustext = item['@GPUType'] != 'None' ? <TableRow><td>GPU Count Per Server:</td> <td>{item["@GPUcount"]}</td> </TableRow> : ''

                }
                if (item["@Type"] === STORAGE_) {
                    text = item['@RoleName'] + "s";
                    Soldisplay = "";
                }
            }
            this.populateTenantDriveList(item);
            if (item['@Type'] !== GATEWAY_) {
                if (item['@Type'] === MASTER_) {
                    text = MASTER_HOST;
                }
                tenantstorage = <TableRow><td>Persistent Drive:</td> <td>{this.state.tenantDriveList}</td> </TableRow>
                tenantstorageqty = <TableRow><td>Persistent Drive Quantity:</td> <td>{this.state.consolidatedTenantDriveQty}</td> </TableRow>
            } else {
                text = GATEWAY_HOSTS;
            }
            if (item['@Type'] === GATEWAY_ || item["@Type"] === CONTROLLER_ || item["@Type"] === MASTER_) {
                VMWareCheckBox = <TableRow><td>VMWare:</td><td>{item["@VMWare"]}</td></TableRow>
            }

            return (
                <Box size='xlarge' separator='bottom' style={{ display: Soldisplay }}>
                    <Heading tag="h4" align="center" margin="none" position='fixed' width='100%' style={{ paddingTop: '1%', paddingRight: '5%' }} strong={true} >{text}</Heading>
                    <Box direction='row'>
                        <Box style={{ width: '35%' }}>
                            <Table>
                                <tbody>
                                    <TableRow><td>Host type:</td> <td>{item['@Name']}</td> </TableRow>
                                    <TableRow><td>Processor Type:</td> <td>{item['@Proc']}</td> </TableRow>
                                    <TableRow><td>Processor Family:</td><td>{item['@ProcFamily']}</td> </TableRow>
                                    <TableRow><td>Memory:</td><td>{item['@Memory']}</td> </TableRow>

                                    {totalgpustext}
                                    {tenantstorage}
                                    {VMWareCheckBox}
                                </tbody>
                            </Table>
                        </Box>
                        <Box style={{ width: '50%' }}>
                            <Table>
                                <tbody>
                                    <TableRow><td>Host Count:</td><td>{item['@NodesCount']}</td> </TableRow>
                                    <TableRow><td>OS Drive:</td><td>{item['@OSDisk']}</td> </TableRow>
                                    <TableRow><td>{driveType} Storage Drive:</td><td>{item['@NodeDisk']}</td> </TableRow>
                                    <TableRow><td>{driveType} Storage Drive Quantity:</td><td>{item['@StorageDiskQty']}</td> </TableRow>
                                    {GPUtext}
                                    {tenantstorageqty}
                                </tbody>
                            </Table>
                        </Box>
                    </Box>
                </Box>
            )
        }
        this.props.workload.UserInputs.Environments.Environment.filter(solution => solution["@isSelected"] === "yes").map(selectedSolution => {
            let workloadTemplate = "Select Workload Template";
            let virtualClustersLabel = "Number of clusters (or Applications)";
            let virtualNodesLabel = "Nodes/Containers (or pod) per cluster";
            let cpuCoresLabel = "Cores per container (or pod)";
            let memoryLabel = "Memory GB per container (or pod)";
            let nodeStorageLabel = "Ephemeral Storage GB per container (or pod)";
            let persistentStorageLabel = "Persistent Storage GB per cluster (or pod)"
            let gpusLabel = "GPUs per container (or pod)";
            let inferenceImageProcessing = '';
            let inferenceGPU = '';
            let trainingImageProcessing = '';
            let trainingGPU = '';
            let MLOpsTemplateInput = false;
            let MLOpsImageProcessing = false;
            let HPECPWorkloadRequirementsHeading = commonConstants.HPECPWorkloadRequirements.CP
            let HPECPRequirementsHeading = commonConstants.HPECPWorkloadRequirements.CP.replace(commonConstants.Workload, "");
            if (!this.props.workload.UserInputs.Environments.WorkloadRequirementsHeading) {
                this.props.workload.UserInputs.Environments.WorkloadRequirementsHeading = commonConstants.HPECPWorkloadRequirements[this.props.workload.UserInputs.Environments.SSETMode];
            }
            HPECPWorkloadRequirementsHeading = this.props.workload.UserInputs.Environments.WorkloadRequirementsHeading;
            if (!this.props.workload.UserInputs.Environments.RequirementsHeading) {
                this.props.workload.UserInputs.Environments.RequirementsHeading = HPECPWorkloadRequirementsHeading.replace(commonConstants.Workload, "")
            }
            HPECPRequirementsHeading = this.props.workload.UserInputs.Environments.RequirementsHeading;

            if (selectedSolution[ATTRIBUTE_SOLUTIONTYPE] === CAAS) {
                const index = selectedSolution.Templates.Template.findIndex(template => template[ATTRIBUTE_TYPE] === IMAGE_PROCESSING_TEMPLATE);
                if (index > -1) {
                    selectedSolution.Templates.Template.splice(index, 1);
                }
            }
            let templatesTableBody = selectedSolution.Templates.Template.map((val) => {
                if (selectedSolution["@SolutionType"] !== MLOPS || (selectedSolution["@SolutionType"] === MLOPS && val["@InputMode"] === MLOPS)) {
                    return (
                        <TableRow> <td style={{ textAlign: 'center' }}>{val['@ConfigType']}</td>
                            <td style={{ textAlign: 'center' }}>{val['@Type']}</td>
                            <td style={{ textAlign: 'center' }} >{val.Nodes['@vClusters']}</td>
                            <td style={{ textAlign: 'center' }}>{val.Nodes['@vNodesPerCluster']}</td>
                            <td style={{ textAlign: 'center' }}>{val.Nodes['@vCPUPerNode']}</td>
                            <td style={{ textAlign: 'center' }}>{val.Nodes['@vMemoryPerNode']}</td>
                            <td style={{ textAlign: 'center' }}>{val.Nodes['@StoragePervNode']}</td>
                            <td style={{ textAlign: 'center' }}>{val.Nodes['@PersistentStorage']}</td>
                            <td style={{ textAlign: 'center' }}>{val.Nodes['@userGPUs']}</td>
                        </TableRow>
                    )
                }
            });
            if (selectedSolution["@SolutionType"] === MLOPS) {
                if (selectedSolution.Templates.Template.find(template => template["@Type"] !== NONE_ && template["@InputMode"] === MLOPS)) {
                    MLOpsTemplateInput = true;
                }
                if (selectedSolution.Templates.Template.find(template => template["@Type"] !== NONE_ && template["@InputMode"] === IMAGE_PROCESSING)) {
                    MLOpsImageProcessing = true;
                }
            }
            let overallConfigType = EPIC_;
            if (selectedSolution["@SolutionType"] !== MLOPS || (selectedSolution["@SolutionType"] === MLOPS && MLOpsTemplateInput)) {
                if (selectedSolution.Templates.Template.filter(template => template["@Type"] !== NONE_).length === 0) {
                    overallConfigType = selectedSolution.Templates.Template.find(template => template["@Type"] === NONE_)["@ConfigType"];
                } else {
                    let kubernetesTemplates = [];
                    kubernetesTemplates = selectedSolution.Templates.Template.filter(template => template["@ConfigType"] === KUBERNETES_ && template["@Type"] !== NONE_ && !(selectedSolution["@SolutionType"] === MLOPS && template["@InputMode"] === IMAGE_PROCESSING))
                    if (kubernetesTemplates.length > 0) {
                        overallConfigType = KUBERNETES_;
                    }
                }
            }

            let requirementDetails = (<Box size='xlarge'>
                <Heading tag="h5" align="center" margin="none" position='fixed' style={{ paddingTop: '1%', paddingRight: '5%' }} width='100%' strong={true} >{HPECPRequirementsHeading}</Heading>
                <Box direction='row'>
                    <Table>
                        <tbody>
                            <TableRow>
                                <td>Persistent Storage TB:</td> <td>{selectedSolution.Templates.ServerDetails.Requirements['@HDFSRawSize']}</td>
                                <td>Persistent Storage Replication Factor:</td> <td>{selectedSolution.Templates.ServerDetails.Requirements['@HDFSRepFactor']}</td>
                                <td>vCPU to Physical Core ratio:</td> <td>{selectedSolution.Templates.ServerDetails.Requirements['@AllocationRatio']}</td>
                                {overallConfigType === KUBERNETES_ ?
                                    <Box direction="row">
                                        <td>Number of Kubernetes Cluster(s):</td> <td>{selectedSolution.Templates.ServerDetails.Requirements['@KubernetesClustersQty']}</td>
                                    </Box> : ''}
                            </TableRow>
                            <TableRow>
                                <td>Configure Based on:</td> <td>{selectedSolution.Templates.ServerDetails.Requirements['@ConfigBasedOn']}</td>
                            </TableRow>
                        </tbody>
                    </Table>
                </Box>
            </Box>)

            if (!Array.isArray(selectedSolution.Templates.ServerDetails.Server)) {
                const singleRole = selectedSolution.Templates.ServerDetails.Server;
                selectedSolution.Templates.ServerDetails.Server = [];
                selectedSolution.Templates.ServerDetails.Server.push(singleRole);
            }
            let allRoles = selectedSolution.Templates.ServerDetails.Server;
            let configuredRoles = [];
            if (selectedSolution.NonGPUValue === undefined) {
                selectedSolution.NonGPUValue = { isCalculated: FALSE }
            }
            if (selectedSolution.StorageValue === undefined) {
                selectedSolution.StorageValue = { isCalculated: FALSE }
            }
            if (selectedSolution.GPUValue === undefined) {
                selectedSolution.GPUValue = { isCalculated: FALSE }
            }
            allRoles.map((role) => {
                if (role["@Type"] === NONGPU_ && parseInt(role["@NodesCount"], 10) > 0) {
                    selectedSolution.NonGPUValue.isCalculated = TRUE;
                }
                if (role["@Type"] === GPU_ && parseInt(role["@NodesCount"], 10) > 0) {
                    selectedSolution.GPUValue.isCalculated = TRUE;
                }
                if (role["@Type"] === STORAGE_ && parseInt(role["@NodesCount"], 10) > 0) {
                    selectedSolution.StorageValue.isCalculated = TRUE;
                }
                if (this.validateServer(role, selectedSolution, MLOpsImageProcessing)) {
                    configuredRoles.push(createRole(role, selectedSolution));
                }
            });

            if (selectedSolution["@SolutionType"] === MLOPS) {
                if (MLOpsImageProcessing) {
                    selectedSolution.Templates.Template.map(template => {
                        if (!selectedSolution.Templates.Template.find(template => template[ATTRIBUTE_INPUTMODE] === IMAGE_PROCESSING && template[ATTRIBUTE_TYPE] === INFERENCE_)) {
                            if (template[ATTRIBUTE_INPUTMODE] === IMAGE_PROCESSING && template[ATTRIBUTE_CATEGORY] === INFERENCE_ && template[ATTRIBUTE_TYPE] !== INFERENCE_) {
                                template[ATTRIBUTE_TYPE] = INFERENCE_;
                            }
                        }
                        if (!selectedSolution.Templates.Template.find(template => template[ATTRIBUTE_INPUTMODE] === IMAGE_PROCESSING && template[ATTRIBUTE_TYPE] === TRAINING)) {
                            if (template[ATTRIBUTE_INPUTMODE] === IMAGE_PROCESSING && template[ATTRIBUTE_CATEGORY] === TRAINING && template[ATTRIBUTE_TYPE] !== TRAINING) {
                                template[ATTRIBUTE_TYPE] = TRAINING;
                            }
                        }
                    })
                    const inferenceTemplate = selectedSolution.Templates.Template.find(template => template["@Type"] === INFERENCE_);
                    const trainingTemplate = selectedSolution.Templates.Template.find(template => template["@Type"] === TRAINING);
                    inferenceImageProcessing = inferenceTemplate.Nodes["@ImagesPerSec"];
                    inferenceGPU = inferenceTemplate.Nodes["@GPUType"];
                    trainingImageProcessing = trainingTemplate.Nodes["@ImagesPerSec"];
                    trainingGPU = trainingTemplate.Nodes["@GPUType"];
                }
            }

            mainScreenandManagementHosts.push(
                <Box style={{ borderBottom: '2px solid #01a982' }}>
                    <Box separator='bottom'>
                        <Heading tag="h4" align="center" margin="none" position='fixed' width='100%' style={{ paddingTop: '1%', paddingRight: '5%' }} strong={true} >{selectedSolution["@SolutionType"]}</Heading>
                        <Heading tag="h5" align="center" margin="none" position='fixed' width='100%' style={{ paddingTop: '1%', paddingRight: '5%' }} strong={true} >{HPECPWorkloadRequirementsHeading}</Heading>
                        {selectedSolution["@SolutionType"] !== MLOPS || (selectedSolution["@SolutionType"] === MLOPS && MLOpsTemplateInput) ?
                            <Box>
                                {selectedSolution["@SolutionType"] === MLOPS && MLOpsTemplateInput ?
                                    <Heading tag="h5" align="center" margin="none" position='fixed' style={{ paddingTop: '1%', paddingRight: '5%' }} width='100%' strong={true} >{MLOPS_TEMPLATES}</Heading>
                                    : ''}
                                <Table>
                                    <thead>
                                        <tr>
                                            <th>Configuration Type</th>
                                            <th>{workloadTemplate}</th>
                                            <th>{virtualClustersLabel}</th>
                                            <th>{virtualNodesLabel}</th>
                                            <th>{cpuCoresLabel}</th>
                                            <th>{memoryLabel}</th>
                                            <th>{nodeStorageLabel}</th>
                                            <th>{persistentStorageLabel}</th>
                                            <th>{gpusLabel}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {templatesTableBody}
                                    </tbody>
                                </Table>
                            </Box> :
                            ''}
                        {selectedSolution["@SolutionType"] === MLOPS && MLOpsImageProcessing ?
                            <Box>
                                <Heading tag="h5" align="center" margin="none" position='fixed' style={{ paddingTop: '1%', paddingRight: '5%' }} width='100%' strong={true} >{MLOPS_IMAGE_PROCESSING}</Heading>
                                <Table>
                                    <thead>
                                        <tr>
                                            <th><Heading tag="h4" strong={true} align="center">{INFERENCE_}</Heading></th>
                                            <th><Heading tag="h4" align="center" strong={true}>{TRAINING}</Heading></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <td>
                                                    <td>Image Processing Input:</td>
                                                    <td>{inferenceImageProcessing}</td>
                                                </td>
                                                <td>
                                                    <td>GPUs:</td>
                                                    <td>{inferenceGPU}</td>
                                                </td>
                                            </td>
                                            <td>
                                                <td>
                                                    <td>Image Processing Input:</td>
                                                    <td>{trainingImageProcessing}</td>
                                                </td>
                                                <td>
                                                    <td>GPUs:</td>
                                                    <td>{trainingGPU}</td>
                                                </td>
                                            </td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </Box> :
                            ''
                        }
                    </Box>
                    {requirementDetails}
                    {configuredRoles}
                </Box>
            )

        })

        let managementRoles = this.props.workload.UserInputs.Environments.ManagementHosts.Server.map(role => {
            return createRole(role);
        })
        mainScreenandManagementHosts.push(managementRoles);
        return mainScreenandManagementHosts;
    }
    createRow = (filteredItem) => {
        //(isNaN(this.props.defaultSizerWorkload.GatewayQty) || this.props.defaultSizerWorkload.GatewayQty === null)
        let filteredItemType;
        filteredItemType = filteredItem["@RoleName"] ? `${filteredItem["@SolutionType"]}-${filteredItem["@RoleName"]}` : filteredItem["@SolutionType"];

        return <TableRow>
            <td>
                {filteredItemType}
            </td>
            <td>
                <Label style={{ width: '30%' }} id='item1'>{filteredItem["@GrowthRate"]} </Label>
            </td>
            <td>
                <Label style={{ marginLeft: '30%' }}>{filteredItem["@Nodes1Y"]}</Label>
            </td>
            <td>
                <Label style={{ marginLeft: '30%' }}>{filteredItem["@Nodes2Y"]}</Label>
            </td>
            <td className='secondary'>
                <Label style={{ marginLeft: '30%' }}>{filteredItem["@Nodes3Y"]}</Label>
            </td>
            <td className='secondary'>
                <Label style={{ marginLeft: '30%' }}>{filteredItem["@Nodes4Y"]}</Label>
            </td>
        </TableRow>
    }

    render() {
        let Hdngwid = '50%';
        let Datawid = '50%';
        let txtalgn = 'left';
        let fntwght = '600';
        let HadoopServicesScreen = '';
        let LicensingHeading = '';
        let InfrastructureScrn = '';
        let EzemeralGrowthScrn = '';
        let displayGrowth = true;
        var Services = []

        if (this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Cloudera['@IsSelected'] !== 'false' && this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Hortonworks['@IsSelected'] === 'false') {

            this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Cloudera.License.map((name) => {
                if (name['@IsSelected'] === 'true') {
                    Services.push(<Box direction='row' pad={{ between: "small" }}>
                        <span style={{ width: Datawid, textAlign: txtalgn, fontWeight: fntwght }}>{name['@Type']} :</span>
                        <span style={{ width: Datawid, textAlign: txtalgn }} >{name['@Description']}</span>
                    </Box>)
                }
            })

        }
        else if (this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Cloudera['@IsSelected'] === 'false' && this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Hortonworks['@IsSelected'] !== 'false') {

            this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Hortonworks.License.map((name) => {
                if (name['@IsSelected'] === 'true') {
                    Services.push(<Box direction='row' pad={{ between: "small" }}>
                        <span style={{ width: Datawid, textAlign: txtalgn, fontWeight: fntwght }}>{name['@Type']} :</span>
                        <span style={{ width: Datawid, textAlign: txtalgn }} >{name['@Description']}</span>
                    </Box>)
                }
            })
        }

        if (this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.MapR !== undefined) {
            if (this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.MapR['@IsSelected'] === 'true') {
                this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.MapR.License.map((name) => {
                    if (name['@IsSelected'] === 'true') {
                        Services.push(<Box direction='row' pad={{ between: "small" }}>
                            <span style={{ width: Datawid, textAlign: txtalgn, fontWeight: fntwght }}>{name['@Type']} :</span>
                            <span style={{ width: Datawid, textAlign: txtalgn }} >{name['@Description']}</span>
                        </Box>)
                    }
                })
            }
        }
        if (Array.isArray(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License)) {
            this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License.map((software) => {
                let text = ""
                if (software['@Description'] !== 'None') {
                    if (software['@Type'] === HPE_CP) {
                        text = HPE_CP_EPIC_SOFTWARE
                    } else if (software['@Type'] === "BlueDataAI") {
                        text = HPE_CP_ML_SOFTWARE
                    } else if (software["@Type"] === KUBERNETES_CM) {
                        text = HPE_E_CP_EXTERNAL_K8S_CLUSTER_MNGR;
                    } else {
                        text = software['@Type']
                    }
                    Services.push(<Box direction='row' pad={{ between: "small" }}>
                        <span style={{ width: Datawid, textAlign: txtalgn, fontWeight: fntwght }}>{text} :</span>
                        <span style={{ width: Datawid, textAlign: txtalgn }} >{software['@Description']}</span>
                    </Box>)
                }

            })

        }
        if (this.props.workload.UserInputs.Environments.HadoopServices.VMWare) {
            let VMWareLicenses = this.props.workload.UserInputs.Environments.HadoopServices.VMWare;
            for (const key in VMWareLicenses) {
                if (VMWareLicenses[key] !== NONE_) {
                    Services.push(<Box direction='row' pad={{ between: "small" }}>
                        <span style={{ width: Datawid, textAlign: txtalgn, fontWeight: fntwght }}>{`VMWare ${key.substring(1)} :`}</span>
                        <span style={{ width: Datawid, textAlign: txtalgn }} >{VMWareLicenses[key]}</span>
                    </Box>)
                }
            }

        }
        HadoopServicesScreen = <Box pad={{ between: "small" }} style={{ width: '100%', padding: '20px' }}>
            <span style={{ textAlign: "center", fontWeight: fntwght }}>Licenses and Support</span>
            <Box direction='row' pad={{ between: "small" }}>
                <Box pad={{ between: "small" }} style={{ width: '50%' }} >
                    {Services}
                </Box>
                <Box pad={{ between: "small" }} style={{ width: '50%' }} >
                    <span >{LicensingHeading}</span>
                    {this.props.workload.UserInputs.Environments.HadoopServices['HPCM'] !== 'None' ? <span><Box direction="row">
                        <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>HPCM :</Box>
                        <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{this.props.workload.UserInputs.Environments.HadoopServices['HPCM']}</Box>
                    </Box></span> : ''}
                    {this.props.workload.UserInputs.Environments.HadoopServices['HWSupport'] !== 'None' ? <span><Box direction="row">
                        <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>HWSupport :</Box>
                        <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{this.props.workload.UserInputs.Environments.HadoopServices['HWSupport']}</Box>
                    </Box></span> : ''}
                    {this.props.workload.UserInputs.Environments.HadoopServices['HadoopLicense'] !== 'None' ? <span><Box direction="row">
                        <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>HadoopLicense :</Box>
                        <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{this.props.workload.UserInputs.Environments.HadoopServices['HadoopLicense']}</Box>
                    </Box></span> : ''}
                    {this.props.workload.UserInputs.Environments.HadoopServices['LinuxLicense'] !== 'None' ? <span><Box direction="row">
                        <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>LinuxLicense :</Box>
                        <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{this.props.workload.UserInputs.Environments.HadoopServices['LinuxLicense']}</Box>
                    </Box></span> : ''}

                    {this.props.workload.UserInputs.Environments.HadoopServices['iLoLicense'] !== 'None' ? <span><Box direction="row">
                        <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>iLoLicense :</Box>
                        <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{this.props.workload.UserInputs.Environments.HadoopServices['iLoLicense']}</Box>
                    </Box></span> : ''}
                    {this.props.workload.UserInputs.Environments.HadoopServices['AppStore'] !== 'false' ? <span><Box direction="row">
                        <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>HPE Ezmeral Runtime Enterprise App Store Development SVC :</Box>
                        <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{this.props.workload.UserInputs.Environments.HadoopServices['AppStore']}</Box>
                    </Box></span> : ''}
                    {this.props.workload.UserInputs.Environments.HadoopServices['Deployment'] !== 'false' ? <span><Box direction="row">
                        <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>HPE Ezmeral Runtime Enterprise Deployment and Integration Services  :</Box>
                        <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{this.props.workload.UserInputs.Environments.HadoopServices['Deployment']}</Box>
                    </Box></span> : ''}
                    {this.props.workload.UserInputs.Environments.HadoopServices['Installation'] !== 'false' ? <span><Box direction="row">
                        <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Installation and Start-up Services :</Box>
                        <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{this.props.workload.UserInputs.Environments.HadoopServices['Installation']}</Box>
                    </Box></span> : ''}
                    {this.props.workload.UserInputs.Environments.HadoopServices.SingleImage['#text'] !== 'false' ? <span><Box direction="row">
                        <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>HPE Ezmeral Runtime Enterprise Single Image Development SVC :</Box>
                        <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{this.props.workload.UserInputs.Environments.HadoopServices.SingleImage["@Qty"]}</Box>
                    </Box></span> : ''}
                    {this.props.workload.UserInputs.Environments.HadoopServices.CustomImage['#text'] !== 'false' ? <span><Box direction="row">
                        <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>HPE Ezmeral Runtime Enterprise Custom Image Development SVC :</Box>
                        <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{this.props.workload.UserInputs.Environments.HadoopServices.CustomImage["@Qty"]}</Box>
                    </Box></span> : ''}
                </Box>
            </Box>
        </Box>
        this.props.workload.UserInputs.Environments.Growth.Host.map(x => {
            if (x["@RoleName"] !== '' && x["@SolutionType"] !== '') {
                EzemeralGrowthScrn = this.props.workload.UserInputs.Environments.Growth.Host.map(x => {
                    if (x["@RoleName"] !== '' && x["@SolutionType"] !== '') {
                        return this.createRow(x);
                    }
                })

            }
        })

        if (this.props.isFromExternalApp) {
            displayGrowth = false;
        }
        this.props.workload.UserInputs.Environments.displayGrowth = displayGrowth.toString();
        //InfraStructure Screen
        InfrastructureScrn = <Box direction='row' style={{ width: '100%' }}>
            <List style={{ width: '100%' }}>
                <ListItem direction="column" separator='horizontal'>
                    <span style={{ fontWeight: '600' }}>Infrastructure</span>
                    <Box direction='row' Pad={{ between: "small" }} style={{ width: '100%' }}>
                        <Box Pad={{ between: "small" }} style={{ width: '50%' }}>
                            <Box direction="row">
                                <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Provision Type:</Box>
                                <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{this.props.workload.UserInputs.Environments.Licenses.ProvisionType}</Box>
                            </Box>
                            <Box direction="row">
                                <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Network Speed:</Box>
                                <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{this.props.workload.UserInputs.Environments.Licenses.NetworkSpeed}</Box>
                            </Box>
                            <Box direction="row">
                                <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Network Switch:</Box>
                                <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{this.props.workload.UserInputs.Environments.Licenses.NetworkSwitch}</Box>
                            </Box>
                            {this.props.workload.UserInputs.Environments.Licenses.AdditionalSwitch !== undefined ? <Box direction="row">
                                <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Additional Network Switch:</Box>
                                <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{this.props.workload.UserInputs.Environments.Licenses.AdditionalSwitch['#text']}</Box>
                            </Box> : ''}
                            {/* Added this.props.workload.UserInputs.Environments.Licenses.AdditionalSwitch["#text"] !== "None" for hiding nummber of network switches when None is selected.*/}
                            {this.props.workload.UserInputs.Environments.Licenses.AdditionalSwitch !== undefined && this.props.workload.UserInputs.Environments.Licenses.AdditionalSwitch["#text"] !== "None" ? <Box direction="row">
                                <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Number of Switches:</Box>
                                <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{this.props.workload.UserInputs.Environments.Licenses.AdditionalSwitch["@Qty"]}</Box>
                            </Box> : ''}
                            <Box direction="row">
                                <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Factory Express:</Box>
                                <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{this.props.workload.UserInputs.Environments.Licenses.FactoryExpress}</Box>
                            </Box>
                        </Box>
                        <Box Pad={{ between: "small" }} style={{ width: '50%' }}>
                            <Box direction="row">
                                <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Max Power:</Box>
                                <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{this.props.workload.UserInputs.Environments.Licenses.MaxPower}</Box>
                            </Box>
                            <Box direction="row">
                                <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Max Weight:</Box>
                                <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{this.props.workload.UserInputs.Environments.Licenses.MaxWeight}</Box>
                            </Box>
                            <Box direction="row">
                                <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Rack:</Box>
                                <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{this.props.workload.UserInputs.Environments.Licenses.Rack}</Box>
                            </Box>
                            <Box direction="row">
                                <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Rack Description:</Box>
                                <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{this.props.workload.UserInputs.Environments.Licenses.RackDescription}</Box>
                            </Box>
                        </Box>
                    </Box>
                </ListItem>
            </List>
        </Box>

        return (
            <Box>
                {this.renderMainScreenandManagementHosts()}
                {HadoopServicesScreen}
                {displayGrowth ?
                    <Box separator='horizontal' style={{ width: '100%', textAlign: 'center' }}>
                        <span style={{ fontWeight: '600' }}>Growth</span>
                        <Table >
                            <thead>
                                <tr>
                                    {
                                        EZMERAL_GROWTH_HEADINGS.map(item =>
                                            <th style={{ fontWeight: '600' }}>
                                                {item}
                                            </th>
                                        )
                                    }
                                </tr>
                            </thead>
                            <tbody>
                                {EzemeralGrowthScrn}
                            </tbody>
                        </Table>
                    </Box> : null}
                {InfrastructureScrn}
            </Box>
        )
    }
}

class SolutionPreviewSynergy extends Component {
    constructor() {
        super();

        this.renderHost = this.renderHost.bind(this);
        this.renderStorage = this.renderStorage.bind(this);
        this.renderGPElement = this.renderGPElement.bind(this);
        this.GPHostContent = this.GPHostContent.bind(this);
        this.GPStorageContent = this.GPStorageContent.bind(this);
        this.renderHostModule = this.renderHostModule.bind(this);
    }

    renderGPElement(Hdngwid, Datawid, txtalgn, fntwght) {
        let sites = undefined;
        sites = this.props.preview.Sites.Site;
        if (sites !== undefined && !Array.isArray(sites))
            sites = [sites];

        if (sites !== undefined) {
            sites.forEach(element => {
                labelsTobeBold.push(element.SiteName)
            });
        }
        return (
            <List style={{ width: '100%' }}>
                <ListItem direction="column" separator='horizontal'>
                    <span separator='horizontal' style={{ fontWeight: '600', textAlign: 'center' }}>Recommended</span>
                    <span separator='horizontal' style={{ fontWeight: '600', textAlign: txtalgn }}>Host Configuration</span>
                    {sites !== undefined ?
                        sites.map(site =>
                            <Box Pad={{ between: "small" }} style={{ width: '100%' }}>
                                <Box direction="row">
                                    <Box style={{ width: '100%', textAlign: 'center', fontWeight: fntwght }} className='secondary'>{site.SiteName}</Box>
                                </Box>
                                {this.GPHostContent(site, fntwght, Hdngwid, txtalgn, Datawid)}
                                {this.GPStorageContent(site, fntwght, Hdngwid, txtalgn, Datawid)}
                                <br />
                            </Box>
                        )
                        : ''}
                </ListItem>
            </List>
        )
    }

    renderHostModule(modules, fntwght, Hdngwid, txtalgn, Datawid, bIsGPElement) {
        let hideDetails = false;
        if (bIsGPElement)
            hideDetails = true;
        return (
            modules !== undefined ?
                modules.map(module =>
                    <Box>
                        {hideDetails ?
                            <Box direction="row">
                                <Box style={{ width: '100%', textAlign: 'center' }} className='secondary'>{module.ModuleName}</Box>
                            </Box> :
                            <Box direction="row">
                                <Box style={{ width: '100%', textAlign: 'center', fontWeight: fntwght, marginTop: '10px' }} className='secondary'>{module.ModuleName}</Box>
                            </Box>}
                        {hideDetails ? '' :
                            <Box direction="row">
                                <Box style={{ width: Hdngwid, textAlign: 'center', fontWeight: fntwght }} className='secondary'>Server:</Box>
                                <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{module.Server}</Box>
                            </Box>}
                        {hideDetails ? '' :
                            <Box direction="row">
                                <Box style={{ width: Hdngwid, textAlign: 'center', fontWeight: fntwght }} className='secondary'>Processor:</Box>
                                <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{module.Processor}</Box>
                            </Box>}
                        {hideDetails ? '' : (module.GPU !== undefined && module.GPU !== '') ?
                            <Box direction="row">
                                <Box style={{ width: Hdngwid, textAlign: 'center', fontWeight: fntwght }} className='secondary'>GPU:</Box>
                                <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{module.GPU}</Box>
                            </Box> : ''}
                        {hideDetails ? '' :
                            <Box direction="row">
                                <Box style={{ width: Hdngwid, textAlign: 'center', fontWeight: fntwght }} className='secondary'>Memory:</Box>
                                <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{module.Memory}</Box>
                            </Box>}
                        {hideDetails ? '' : (module.SystemDrive !== undefined && module.SystemDrive !== '') ?
                            <Box direction="row">
                                <Box style={{ width: Hdngwid, textAlign: 'center', fontWeight: fntwght }} className='secondary'>System Drive:</Box>
                                <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{module.SystemDrive}</Box>
                            </Box> : ''}
                        {hideDetails ? '' : (module.DataDrive !== undefined && module.DataDrive !== '') ?
                            <Box direction="row">
                                <Box style={{ width: Hdngwid, textAlign: 'center', fontWeight: fntwght }} className='secondary'>Data Drive:</Box>
                                <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{module.DataDrive}</Box>
                            </Box> : ''}</Box>) : ''

        )

    }

    GPHostContent(site, fntwght, Hdngwid, txtalgn, Datawid) {
        let modules = site.Modules !== undefined ? site.Modules.Module : undefined;
        if (modules !== undefined && !Array.isArray(modules))
            modules = [modules];

        if (modules !== undefined) {
            modules.forEach(element => {
                labelsTobeBold.push(element.ModuleName)
            });
        }
        let virualHost = [];
        let headHost = [];
        let bareMetalHost = [];
        let containerHost = [];
        let gatewayHost = [];
        let otherModule = [];
        let controlPlane = [];
        let containersOnVM = [];
        let containersOnBareMetal = [];
        let headNode = [];
        let odfStorage = [];
        let coreosVM = [];
        let rehl_BM = [];
        if (this.props.workload.UserInputs.SizerMode === commonConstants.GPELEMENT && modules !== undefined) {
            modules.forEach(element => {
                let moduleCount = element.Server.split('x')[0];

                if (element.ModuleName.indexOf(commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.VIRTUAL_MACHINES) > -1) {
                    let moduleName = element.ModuleName.split('-')[0].trim();
                    element.ModuleName = moduleCount + ' x ' + moduleName;
                    if (element.ReplicationName !== undefined)
                        element.ModuleName = element.ModuleName + element.ReplicationName;

                    virualHost.push(element);
                }
                else if (element.ModuleName.indexOf(commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.CONTAINERSONVM) > -1) {
                    let moduleName = element.ModuleName.split('-')[0].trim();
                    element.ModuleName = moduleCount + ' x ' + moduleName;
                    if (element.ReplicationName !== undefined)
                        element.ModuleName = element.ModuleName + element.ReplicationName;

                    containersOnVM.push(element);

                }
                else if (element.ModuleName.indexOf(commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.CONTAINERSONBAREMETAL) > -1) {
                    let moduleName = element.ModuleName.split('-')[0].trim();
                    element.ModuleName = moduleCount + ' x ' + moduleName;
                    if (element.ReplicationName !== undefined)
                        element.ModuleName = element.ModuleName + element.ReplicationName;

                    containersOnBareMetal.push(element);

                }
                else if (element.ModuleName.indexOf(commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.CONTAINERS) > -1) {
                    let moduleName = element.ModuleName.split('-')[0].trim();
                    element.ModuleName = moduleCount + ' x ' + moduleName;
                    if (element.ReplicationName !== undefined)
                        element.ModuleName = element.ModuleName + element.ReplicationName;

                    containerHost.push(element);

                }
                else if (element.ModuleName.indexOf(commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.COREOS_VM) > -1) {
                    let moduleName = element.ModuleName.split('-')[0].trim();
                    element.ModuleName = moduleCount + ' x ' + moduleName;
                    if (element.ReplicationName !== undefined)
                        element.ModuleName = element.ModuleName + element.ReplicationName;

                    coreosVM.push(element);
                }
                else if (element.ModuleName.indexOf(commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.RHEL_BM) > -1) {
                    let moduleName = element.ModuleName.split('-')[0].trim();
                    element.ModuleName = moduleCount + ' x ' + moduleName;
                    if (element.ReplicationName !== undefined)
                        element.ModuleName = element.ModuleName + element.ReplicationName;

                    rehl_BM.push(element);
                }
                else if (element.ModuleName.indexOf(commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.BARE_METAL) > -1) {
                    let moduleName = element.ModuleName.split('-')[0].trim();
                    element.ModuleName = moduleCount + ' x ' + moduleName;
                    if (element.ReplicationName !== undefined)
                        element.ModuleName = element.ModuleName + element.ReplicationName;

                    bareMetalHost.push(element);
                }
                else if (element.ModuleName.indexOf(commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.HEAD_NODES) > -1) {
                    let moduleName = element.ModuleName.split('-')[0].trim();
                    element.ModuleName = moduleCount + ' x ' + moduleName;
                    if (element.ReplicationName !== undefined)
                        element.ModuleName = element.ModuleName + element.ReplicationName;

                    headHost.push(element);

                }
                else if (element.ModuleName.indexOf(commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.CONTROL_PLANE) > -1) {
                    let moduleName = element.ModuleName.split('-')[0].trim();
                    element.ModuleName = moduleCount + ' x ' + moduleName;
                    if (element.ReplicationName !== undefined)
                        element.ModuleName = element.ModuleName + element.ReplicationName;

                    controlPlane.push(element);

                }
                else if (element.ModuleName.indexOf(commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.GATEWAY) > -1) {
                    let moduleName = element.ModuleName.split('-')[0].trim();
                    element.ModuleName = moduleCount + ' x ' + moduleName;
                    if (element.ReplicationName !== undefined)
                        element.ModuleName = element.ModuleName + element.ReplicationName;

                    gatewayHost.push(element);
                }
                else if (element.ModuleName.indexOf(commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.HEADNODE) > -1) {
                    let moduleName = element.ModuleName.split('-')[0].trim();
                    element.ModuleName = moduleCount + ' x ' + moduleName;
                    if (element.ReplicationName !== undefined)
                        element.ModuleName = element.ModuleName + element.ReplicationName;

                    headNode.push(element);
                }
                else if (element.ModuleName.indexOf(commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.ODF_STORAGE) > -1) {
                    let moduleName = element.ModuleName.split('-')[0].trim();
                    element.ModuleName = moduleCount + ' x ' + moduleName;
                    if (element.ReplicationName !== undefined)
                        element.ModuleName = element.ModuleName + element.ReplicationName;

                    odfStorage.push(element);
                }
                else {
                    otherModule.push(element);
                }
            });
            labelsTobeBold.push(commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.VIRTUAL_MACHINES);
            labelsTobeBold.push(commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.HEAD_NODES);
            labelsTobeBold.push(commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.BARE_METAL);
            labelsTobeBold.push(commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.CONTAINERS);
            labelsTobeBold.push(commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.GATEWAY);
            labelsTobeBold.push(commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.CONTROL_PLANE);
            labelsTobeBold.push(commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.CONTAINERSONVM);
            labelsTobeBold.push(commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.CONTAINERSONBAREMETAL);
            labelsTobeBold.push(commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.HEADNODE);
            labelsTobeBold.push(commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.ODF_STORAGE);
            labelsTobeBold.push(commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.COREOS_VM);
            labelsTobeBold.push(commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.RHEL_BM);
        }
        let bIsGPElement = false;
        if (virualHost.length > 0 || containerHost.length > 0 || containersOnVM.length > 0 || containersOnBareMetal.length > 0 || bareMetalHost.length > 0)
            bIsGPElement = true;

        if (this.props.workload.UserInputs.SizerMode === commonConstants.GPELEMENT) {
            return (
                <Box>
                    {virualHost.length > 0 ?
                        <Box>
                            <Box direction="row">
                                <Box style={{ width: '100%', textAlign: 'center', fontWeight: fntwght, marginTop: '5px' }} className='secondary'>{commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.VIRTUAL_MACHINES}</Box>
                            </Box>
                            {this.renderHostModule(virualHost, fntwght, Hdngwid, txtalgn, Datawid, bIsGPElement)}
                        </Box> : ''}
                    {containersOnVM.length > 0 ?
                        <Box>
                            <Box direction="row">
                                <Box style={{ width: '100%', textAlign: 'center', fontWeight: fntwght, marginTop: '5px' }} className='secondary'>{commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.CONTAINERSONVM}</Box>
                            </Box>
                            {this.renderHostModule(containersOnVM, fntwght, Hdngwid, txtalgn, Datawid, bIsGPElement)}
                        </Box> : ''}
                    {containersOnBareMetal.length > 0 ?
                        <Box>
                            <Box direction="row">
                                <Box style={{ width: '100%', textAlign: 'center', fontWeight: fntwght, marginTop: '5px' }} className='secondary'>{commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.CONTAINERSONBAREMETAL}</Box>
                            </Box>
                            {this.renderHostModule(containersOnBareMetal, fntwght, Hdngwid, txtalgn, Datawid, bIsGPElement)}
                        </Box> : ''}
                    {containerHost.length > 0 ?
                        <Box>
                            <Box direction="row">
                                <Box style={{ width: '100%', textAlign: 'center', fontWeight: fntwght, marginTop: '5px' }} className='secondary'>{commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.CONTAINERS}</Box>
                            </Box>
                            {this.renderHostModule(containerHost, fntwght, Hdngwid, txtalgn, Datawid, bIsGPElement)}
                        </Box> : ''}
                    {bareMetalHost.length > 0 ?
                        <Box>
                            <Box direction="row">
                                <Box style={{ width: '100%', textAlign: 'center', fontWeight: fntwght, marginTop: '5px' }} className='secondary'>{commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.BARE_METAL}</Box>
                            </Box>
                            {this.renderHostModule(bareMetalHost, fntwght, Hdngwid, txtalgn, Datawid, bIsGPElement)}
                        </Box> : ''}
                    {headHost.length > 0 ?
                        <Box>
                            <Box direction="row">
                                <Box style={{ width: '100%', textAlign: 'center', fontWeight: fntwght, marginTop: '5px' }} className='secondary'>{commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.HEAD_NODES}</Box>
                            </Box>
                            {this.renderHostModule(headHost, fntwght, Hdngwid, txtalgn, Datawid, bIsGPElement)}
                        </Box> : ''}
                    {controlPlane.length > 0 ?
                        <Box>
                            <Box direction="row">
                                <Box style={{ width: '100%', textAlign: 'center', fontWeight: fntwght, marginTop: '5px' }} className='secondary'>{commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.CONTROL_PLANE}</Box>
                            </Box>
                            {this.renderHostModule(controlPlane, fntwght, Hdngwid, txtalgn, Datawid, bIsGPElement)}
                        </Box> : ''}
                    {gatewayHost.length > 0 ?
                        <Box>
                            <Box direction="row">
                                <Box style={{ width: '100%', textAlign: 'center', fontWeight: fntwght, marginTop: '5px' }} className='secondary'>{commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.GATEWAY}</Box>
                            </Box>
                            {this.renderHostModule(gatewayHost, fntwght, Hdngwid, txtalgn, Datawid, bIsGPElement)}
                        </Box> : ''}
                    {headNode.length > 0 ?
                        <Box>
                            <Box direction="row">
                                <Box style={{ width: '100%', textAlign: 'center', fontWeight: fntwght, marginTop: '5px' }} className='secondary'>{commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.HEADNODE}</Box>
                            </Box>
                            {this.renderHostModule(headNode, fntwght, Hdngwid, txtalgn, Datawid, bIsGPElement)}
                        </Box> : ''}
                    {odfStorage.length > 0 ?
                        <Box>
                            <Box direction="row">
                                <Box style={{ width: '100%', textAlign: 'center', fontWeight: fntwght, marginTop: '5px' }} className='secondary'>{commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.ODF_STORAGE}</Box>
                            </Box>
                            {this.renderHostModule(odfStorage, fntwght, Hdngwid, txtalgn, Datawid, bIsGPElement)}
                        </Box> : ''}
                        {coreosVM.length > 0 ?
                        <Box>
                            <Box direction="row">
                                <Box style={{ width: '100%', textAlign: 'center', fontWeight: fntwght, marginTop: '5px' }} className='secondary'>{commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.COREOS_VM}</Box>
                            </Box>
                            {this.renderHostModule(coreosVM, fntwght, Hdngwid, txtalgn, Datawid, bIsGPElement)}
                        </Box> : ''}
                        {rehl_BM.length > 0 ?
                        <Box>
                            <Box direction="row">
                                <Box style={{ width: '100%', textAlign: 'center', fontWeight: fntwght, marginTop: '5px' }} className='secondary'>{commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.RHEL_BM}</Box>
                            </Box>
                            {this.renderHostModule(rehl_BM, fntwght, Hdngwid, txtalgn, Datawid, bIsGPElement)}
                        </Box> : ''}
                    {otherModule.length > 0 ?
                        this.renderHostModule(otherModule, fntwght, Hdngwid, txtalgn, Datawid, bIsGPElement)
                        : ''}
                </Box>

            )
        }
        else {
            { this.renderHostModule(modules, fntwght, Hdngwid, txtalgn, Datawid, bIsGPElement) }
        }
    }

    GPStorageContent(site, fntwght, Hdngwid, txtalgn, Datawid) {
        let storagemodules = site.StorageModules !== undefined && site.StorageModules !== null ? site.StorageModules.StorageModule : undefined;
        if (storagemodules !== undefined && !Array.isArray(storagemodules))
            storagemodules = [storagemodules];

        if (this.props.workload.UserInputs.SizerMode !== commonConstants.GPELEMENT && storagemodules !== undefined) {
            storagemodules.forEach(element => {
                labelsTobeBold.push(element.StorageModuleName)
            });
        }
        let sharedHeading = undefined;
        let sharedStorageHeading = undefined;
        let hideStorageDetails = false;
        if (this.props.workload.UserInputs.SizerMode === commonConstants.GPELEMENT && storagemodules !== undefined) {
            hideStorageDetails = true;
            sharedHeading = commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.SHARED;
            sharedStorageHeading = commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.SHAREDSTORAGE;
            labelsTobeBold.push(commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.SHARED);
            labelsTobeBold.push(commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.SHAREDSTORAGE);
        }
        if (site.SiteName === '') {
            hideStorageDetails = false;
            sharedHeading = undefined;
            sharedStorageHeading = undefined;
        }

        return (
            <Box style={{ position: "relative", top: "10px" }}>
                {storagemodules !== undefined ?
                    <Box>
                        <Box>
                            <Box direction="row">
                                <Box style={{ width: '100%', textAlign: 'center', fontWeight: fntwght, position: "relative", bottom: "10px", marginTop: '5px' }} className='secondary'>{sharedStorageHeading}</Box>
                            </Box>
                        </Box>
                    </Box> : ''}

                {/* {storagemodules!==undefined?
                storagemodules.map(storagemodule =>                 
                    <Box>
                        {hideStorageDetails?
                        <Box direction="row">
                            {storagemodule.StorageModuleName.search(commonConstants.PRIMERA)> 0 ? 
                            <Box direction="row">
                                <Box style={{ width: '100%', textAlign: 'center', fontWeight: fntwght, position: "absolute", bottom: "20px"}} className='secondary'>{sharedStorageHeading}</Box> 
                            </Box>
                            : 
                            <Box direction="row">
                                <Box style={{ width: '100%', textAlign: 'center', fontWeight: fntwght, position: "relative", bottom:"15px", left: "550px"}} className='secondary'>{sharedHeading}</Box>
                            </Box>  }
                        </Box> : 
                        <Box direction="row">
                            <Box style={{ width: '100%', textAlign: 'center', fontWeight: fntwght, position: "relative", bottom:"15px", left: "550px"}} className='secondary'>{sharedHeading}</Box>
                        </Box>
                    }                                       
                </Box>): ''} */}
                {storagemodules !== undefined ?
                    storagemodules.map(storagemodule =>
                        <Box>
                            {hideStorageDetails ?
                                <Box direction="row">
                                    {storagemodule.StorageModuleName.search(commonConstants.PRIMERA) > 0 ?
                                        <Box direction="row">
                                            <Box style={{ width: "100%", textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>{commonConstants.STORAGEHEADING}</Box>
                                            <Box style={{ width: "100%", textAlign: txtalgn, position: "absolute", left: "35%" }} className='secondary'>{storagemodule.StorageModuleName}</Box>
                                        </Box>
                                        :
                                        <Box style={{ width: '100%', textAlign: 'center', position: "relative", bottom: "10px" }} className='secondary'>{storagemodule.StorageModuleName}</Box>}
                                </Box>
                                :
                                <Box direction="row">
                                    {storagemodule.StorageModuleName.search(commonConstants.PRIMERA) > 0 ?
                                        <Box direction="row">
                                            <Box style={{ width: "100%", textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>{commonConstants.STORAGEHEADING}</Box>
                                            <Box style={{ width: "100%", textAlign: txtalgn, position: "absolute", left: "35%" }} className='secondary'>{storagemodule.StorageModuleName}</Box>
                                        </Box>
                                        :
                                        <Box style={{ width: '100%', textAlign: 'center', fontWeight: fntwght, position: "relative", bottom: "10px" }} className='secondary'>{storagemodule.StorageModuleName}</Box>}
                                </Box>}

                            {!hideStorageDetails && storagemodule.NimbleStorage.Controller !== undefined ?
                                <Box direction="row">
                                    <Box style={{ width: Hdngwid, textAlign: 'center', fontWeight: fntwght }} className='secondary'>Controller:</Box>
                                    <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{storagemodule.NimbleStorage.Controller}</Box>
                                </Box> : ''}
                            {!hideStorageDetails && storagemodule.NimbleStorage.Capacities !== undefined ?
                                <Box direction="row">
                                    <Box style={{ width: Hdngwid, textAlign: 'center', fontWeight: fntwght }} className='secondary'>Capacity:</Box>
                                    <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{storagemodule.NimbleStorage.Capacities}</Box>
                                </Box> : ''}
                            {!hideStorageDetails && storagemodule.NimbleStorage.Caches !== undefined ?
                                <Box direction="row">
                                    <Box style={{ width: Hdngwid, textAlign: 'center', fontWeight: fntwght }} className='secondary'>Cache:</Box>
                                    <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{storagemodule.NimbleStorage.Caches}</Box>
                                </Box> : ''}
                            {/* {storagemodule.NimbleStorage.Networking !== undefined ?
                            <Box direction="row">
                                <Box style={{ width: Hdngwid, textAlign: 'center', fontWeight: fntwght }} className='secondary'>Networking:</Box>
                                <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{storagemodule.NimbleStorage.Networking}</Box>
                            </Box> : ''} */}</Box>) : ''}
            </Box>
        )

    }

    renderHost(Hdngwid, Datawid, txtalgn, fntwght) {
        let roleServer = this.props.preview.roles.serverRoles.serverRole
        if (!Array.isArray(roleServer))
            roleServer = [roleServer];

        roleServer.forEach(element => {
            labelsTobeBold.push(element.roleName)
        });


        return (
            <List style={{ width: '100%' }}>
                <ListItem direction="column" separator='horizontal'>
                    <span separator='horizontal' style={{ fontWeight: '600', textAlign: 'center' }}>Recommended</span>
                    <span separator='horizontal' style={{ fontWeight: '600', textAlign: txtalgn }}>Host Configuration</span>

                    {roleServer.map(serverRole =>
                        <Box Pad={{ between: "small" }} style={{ width: '100%' }}>
                            <Box direction="row">
                                <Box style={{ width: '100%', textAlign: 'center', fontWeight: fntwght, lineHeight: '3rem' }} className='secondary'>{serverRole.roleName}</Box>
                            </Box>
                            <Box direction="row">
                                <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Server:</Box>
                                <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{serverRole.server}</Box>
                            </Box>
                            {serverRole.vSANReadyNode!=undefined?
                            <Box direction="row">
                                <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Ready Node:</Box>
                                <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{serverRole.vSANReadyNode}</Box>
                            </Box>:''}
                            <Box direction="row">
                                <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Number of Servers:</Box>
                                <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{serverRole.noOfserver}</Box>
                            </Box>
                            <Box direction="row">
                                <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Processor Model:</Box>
                                <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{serverRole.CPUModel}</Box>
                            </Box>
                            <Box direction="row">
                                <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Required Ram:</Box>
                                <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{serverRole.memoryPerServer}</Box>
                            </Box>
                            <Box direction="row">
                                <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Local Boot Drive Count:</Box>
                                <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{serverRole.localBootDrive}</Box>
                            </Box>
                            <Box direction="row">
                                <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Local Boot Drive Type:</Box>
                                <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{serverRole.localBootDriveType}</Box>
                            </Box>
                        </Box>
                    )}
                </ListItem>
            </List>
        )

    }

    renderStorage(Hdngwid, Datawid, txtalgn, fntwght) {
        if (this.props.preview.roles.storage === undefined || this.props.preview.roles.storage === null)
            return '';

        let volumes = this.props.preview.roles.storage.volumes;
        if (volumes !== undefined && !Array.isArray(volumes.volume))
            volumes.volume = [volumes.volume];

        let frames = this.props.preview.roles.storage.frames;
        if (frames !== undefined && !Array.isArray(frames.frame))
            frames.frame = [frames.frame];

        let NimbleStorage = this.props.preview.roles.storage.NimbleStorage;
        if (NimbleStorage !== undefined && !Array.isArray(NimbleStorage))
            NimbleStorage = [NimbleStorage];

        return (
            <List style={{ width: '100%' }}>
                <ListItem direction="column" separator='horizontal'>
                    <span separator='horizontal' style={{ fontWeight: '600', textAlign: txtalgn }}>Storage Configuration</span>
                    <Box Pad={{ between: "small" }} style={{ width: '100%' }}>
                        <Box direction="row">
                            <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Storage Type:</Box>
                            <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{this.props.preview.roles.storage.storageType}</Box>
                        </Box>
                        {this.props.preview.roles.storage.arrayModel !== undefined ?
                            <Box direction="row">
                                <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Array Model:</Box>
                                <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{this.props.preview.roles.storage.arrayModel}</Box>
                            </Box> : ''}
                        {volumes !== undefined ?
                            volumes.volume.map(vol =>
                                <Box>
                                    <Box direction="row">
                                        <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Volume Name:</Box>
                                        <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{vol.volumeName}</Box>
                                    </Box>
                                    {vol.lunType !== undefined ?
                                        <Box direction="row">
                                            <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Lun Type:</Box>
                                            <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{vol.lunType}</Box>
                                        </Box> : ''}
                                    <Box direction="row">
                                        <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Disk:</Box>
                                        <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{vol.disk}</Box>
                                    </Box>
                                    <Box direction="row">
                                        <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Disk Quantity:</Box>
                                        <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{vol.diskQty}</Box>
                                    </Box>
                                    {vol.raidLevel !== undefined ?
                                        <Box direction="row">
                                            <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Raid Level:</Box>
                                            <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{vol.raidLevel}</Box>
                                        </Box> : ''}
                                </Box>
                            ) : ''}

                        {frames !== undefined ?
                            frames.frame.map(frm =>
                                <Box>
                                    <Box direction="row">
                                        <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Frame Name:</Box>
                                        <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{frm.frameName}</Box>
                                    </Box>
                                    {frm.volumes.volume !== undefined && Array.isArray(frm.volumes.volume) ?
                                        frm.volumes.volume.map(vol =>
                                            <Box>
                                                <Box direction="row">
                                                    <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Volume Name:</Box>
                                                    <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{vol.volumeName}</Box>
                                                </Box>
                                                <Box direction="row">
                                                    <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Disk Type:</Box>
                                                    <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{vol.disk}</Box>
                                                </Box>
                                                <Box direction="row">
                                                    <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Disk Quantity:</Box>
                                                    <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{vol.diskQty}</Box>
                                                </Box>
                                            </Box>
                                        )
                                        :
                                        frm.volumes.volume !== undefined ?
                                            <Box>
                                                <Box direction="row">
                                                    <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Volume Name:</Box>
                                                    <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{frm.volumes.volume.volumeName}</Box>
                                                </Box>
                                                <Box direction="row">
                                                    <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Disk Type:</Box>
                                                    <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{frm.volumes.volume.disk}</Box>
                                                </Box>
                                                <Box direction="row">
                                                    <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Disk Quantity:</Box>
                                                    <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{frm.volumes.volume.diskQty}</Box>
                                                </Box>
                                            </Box> : ''}
                                </Box>) : ''}
                        {NimbleStorage !== undefined ?
                            NimbleStorage.map(nimbleStorage =>
                                <Box>
                                    <Box direction="row">
                                        <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Controller:</Box>
                                        <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{nimbleStorage.Controller}</Box>
                                    </Box>
                                    <Box direction="row">
                                        <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Capacities:</Box>
                                        <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{nimbleStorage.Capacities}</Box>
                                    </Box>
                                    {nimbleStorage.Caches !== undefined ?
                                        <Box direction="row">
                                            <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Caches:</Box>
                                            <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{nimbleStorage.Caches}</Box>
                                        </Box> : ''}
                                    {nimbleStorage.CapacitiesExpansions !== undefined ?
                                        <Box direction="row">
                                            <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Capacities Expansions:</Box>
                                            <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{nimbleStorage.CapacitiesExpansions}</Box>
                                        </Box> : ''}
                                    {nimbleStorage.Networking !== undefined ?
                                        <Box direction="row">
                                            <Box style={{ width: Hdngwid, textAlign: txtalgn, fontWeight: fntwght }} className='secondary'>Networking:</Box>
                                            <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{nimbleStorage.Networking}</Box>
                                        </Box> : ''}
                                </Box>
                            ) : ''}
                    </Box>
                </ListItem>
            </List>
        )
    }
    render() {
        let Hdngwid = '35%'
        let Datawid = '65%'
        let txtalgn = 'left'
        let fntwght = '600'
        let host = undefined;
        let storage = undefined;
        let previewGP = undefined;
        let sizermode = '';
        if (this.props.workload !== undefined) {
            if (this.props.workload.Workload !== undefined)
                sizermode = this.props.workload.Workload.UserInputs.SizerMode;
            else
                sizermode = this.props.workload.UserInputs.SizerMode;
        }

        if (sizermode !== commonConstants.GPELEMENT) {
            host = this.renderHost(Hdngwid, Datawid, txtalgn, fntwght);
            storage = this.renderStorage(Hdngwid, Datawid, txtalgn, fntwght);
        }
        else
            previewGP = this.renderGPElement(Hdngwid, Datawid, txtalgn, fntwght);

        return (
            <Box id={ID_SOLUTION_PREVIEW}>
                {host}
                {storage}
                {previewGP}
            </Box>
        )
    }
}

class SolutionPreviewSAP extends Component {
    constructor() {
        super();
    }
    renderSAPSolPreview = () => {
        var ProdCentralServerContent;
        var TestQASysContent;
        var TrainingSystem;
        var DevSysContent;
        var SandBoxContent;
        var roleServers;

        if (this.props.SAPSolPreview && !Array.isArray(this.props.SAPSolPreview)) {
            roleServers = [this.props.SAPSolPreview];
        }
        if (roleServers === undefined) {
            return '';
        }

        if (!Array.isArray(this.props.SAPSolPreview.SolutionPreview.roles.serverRoles)) {
            this.props.SAPSolPreview.SolutionPreview.roles.serverRoles = [this.props.SAPSolPreview.SolutionPreview.roles.serverRoles];
        }

        {
            roleServers.map(sol =>
                sol.SolutionPreview.roles.serverRoles.map(serverRole =>
                    (serverRole.serverRole.roleName === 'ProdCentralServer') || (serverRole.serverRole.roleName === 'ProdCentralCluster') ? ProdCentralServerContent = <Box Pad={{ between: "small" }} style={{ width: '100%' }} >
                        <Box direction="row" style={{ borderBottom: '1px solid rgba(0,0,0,.15)' }}>
                            {/* <Box style={{ width: '100%', marginLeft: '25%' }} className='secondary'><b>Role Name:</b> Prod Central</Box> */}
                            {/* <Box style={{ width: '100%', marginLeft: '25%' }} className='secondary'><b>{serverRole.serverRole.roleName}</b></Box> */}
                            <Box style={{ width: '100%', marginLeft: '25%' }}>
                                <span style={{ width: '100%', fontWeight: '600', margin: '10px 0' }}>{serverRole.serverRole.roleName}</span>
                            </Box>
                        </Box>
                        <Box direction="row">
                            <Box style={{ width: '100%' }} className='secondary'><b>Server:</b></Box>
                            <Box style={{ width: '100%' }} className='secondary'>{serverRole.serverRole.server}</Box>
                        </Box>
                        <Box direction="row">
                            <Box style={{ width: '100%' }} className='secondary'><b>CPU Model:</b></Box>
                            <Box style={{ width: '100%' }} className='secondary'>{serverRole.serverRole.CPUModel}</Box>
                        </Box>
                        <Box direction="row">
                            <Box style={{ width: '100%' }} className='secondary'><b>SAPS:</b></Box>
                            <Box style={{ width: '100%' }} className='secondary'>{serverRole.serverRole.SAPS}</Box>
                        </Box>
                        <Box direction="row">
                            <Box style={{ width: '100%' }} className='secondary'><b>Data Base Size:</b></Box>
                            <Box style={{ width: '100%' }} className='secondary'>{serverRole.serverRole.DataBaseSize}</Box>
                        </Box>
                        <Box direction="row">
                            <Box style={{ width: '100%' }} className='secondary'><b>Configuration Type:</b></Box>
                            <Box style={{ width: '100%' }} className='secondary'>{serverRole.serverRole.ConfigurationType}</Box>
                        </Box>
                        <Box direction="row">
                            <Box style={{ width: '100%' }} className='secondary'><b>DB Server CPU Capacity:</b></Box>
                            <Box style={{ width: '100%' }} className='secondary'>{serverRole.serverRole.DBServerCPUCapacity}</Box>
                        </Box>
                        <Box direction="row">
                            <Box style={{ width: '100%' }} className='secondary'><b>Data Base Type:</b></Box>
                            <Box style={{ width: '100%' }} className='secondary'>{serverRole.serverRole.DataBaseType}</Box>
                        </Box>
                        <Box direction="row">
                            <Box style={{ width: '100%' }} className='secondary'><b>Operating System:</b></Box>
                            <Box style={{ width: '100%' }} className='secondary'>{serverRole.serverRole.OperatingSystem}</Box>
                        </Box>
                    </Box> : '')
            )
        }
        {
            roleServers.map(sol =>
                sol.SolutionPreview.roles.serverRoles.map(serverRole =>
                    serverRole.serverRole.roleName === 'Test/Quality Assurance System' ? TestQASysContent = <Box Pad={{ between: "small" }} style={{ width: '100%' }}>
                        <Box direction="row" style={{ borderBottom: '1px solid rgba(0,0,0,.15)' }}>
                            <Box style={{ width: '100%', marginLeft: '25%' }}>
                                <span style={{ width: '100%', fontWeight: '600', margin: '10px 0' }}>{serverRole.serverRole.roleName}</span>
                            </Box>
                        </Box>
                        <Box direction="row">
                            <Box style={{ width: '100%' }} className='secondary'><b>Server:</b></Box>
                            <Box style={{ width: '100%' }} className='secondary'>{serverRole.serverRole.server}</Box>
                        </Box>
                        <Box direction="row">
                            <Box style={{ width: '100%' }} className='secondary'><b>CPU Percentage:</b></Box>
                            <Box style={{ width: '100%' }} className='secondary'>{serverRole.serverRole.CPUPercentage}</Box>
                        </Box>
                        <Box direction="row">
                            <Box style={{ width: '100%' }} className='secondary'><b>Storage Percentage:</b></Box>
                            <Box style={{ width: '100%' }} className='secondary'>{serverRole.serverRole.StoragePercentage}</Box>
                        </Box>
                        <Box direction="row">
                            <Box style={{ width: '100%' }} className='secondary'><b>CPU Model:</b></Box>
                            <Box style={{ width: '100%' }} className='secondary'>{serverRole.serverRole.CPUModel}</Box>
                        </Box>
                    </Box> : '')
            )
        }
        // {
        //     roleServers.map(sol =>
        //         sol.SolutionPreview.roles.serverRoles.map(serverRole =>
        //             serverRole.serverRole.roleName === 'Test/Quality Assurance System' ? TestQASysContent = <Box Pad={{ between: "small" }} style={{ width: '100%' }} separator='horizontal'>
        //                 <Box direction="row">
        //                     <Box style={{ width: '100%', marginLeft: '25%' }} className='secondary'><b>Role Name:</b> {serverRole.serverRole.roleName}</Box>
        //                 </Box>
        //                 <Box direction="row">
        //                     <Box style={{ width: '100%' }} className='secondary'><b>Server:</b></Box>
        //                     <Box style={{ width: '100%' }} className='secondary'>{serverRole.serverRole.Server}</Box>
        //                 </Box>
        //                 <Box direction="row">
        //                     <Box style={{ width: '100%' }} className='secondary'><b>CPU Percentage:</b></Box>
        //                     <Box style={{ width: '100%' }} className='secondary'>{serverRole.serverRole.CPUPercentage}</Box>
        //                 </Box>
        //                 <Box direction="row">
        //                     <Box style={{ width: '100%' }} className='secondary'><b>Storage Percentage:</b></Box>
        //                     <Box style={{ width: '100%' }} className='secondary'>{serverRole.serverRole.StoragePercentage}</Box>
        //                 </Box>
        //                 <Box direction="row">
        //                     <Box style={{ width: '100%' }} className='secondary'><b>CPU Model:</b></Box>
        //                     <Box style={{ width: '100%' }} className='secondary'>{serverRole.serverRole.CPUModel}</Box>
        //                 </Box>
        //             </Box> : '')
        //     )
        // }
        {
            roleServers.map(sol =>
                sol.SolutionPreview.roles.serverRoles.map(serverRole =>
                    serverRole.serverRole.roleName === 'Training System' ? TrainingSystem = <Box Pad={{ between: "small" }} style={{ width: '100%' }}>
                        <Box direction="row" style={{ borderBottom: '1px solid rgba(0,0,0,.15)' }}>
                            <Box style={{ width: '100%', marginLeft: '25%' }}>
                                <span style={{ width: '100%', fontWeight: '600', margin: '10px 0' }}>{serverRole.serverRole.roleName}</span>
                            </Box>
                        </Box>
                        <Box direction="row">
                            <Box style={{ width: '100%' }} className='secondary'><b>Server:</b></Box>
                            <Box style={{ width: '100%' }} className='secondary'>{serverRole.serverRole.server}</Box>
                        </Box>
                        <Box direction="row">
                            <Box style={{ width: '100%' }} className='secondary'><b>CPU Percentage:</b></Box>
                            <Box style={{ width: '100%' }} className='secondary'>{serverRole.serverRole.CPUPercentage}</Box>
                        </Box>
                        <Box direction="row">
                            <Box style={{ width: '100%' }} className='secondary'><b>Storage Percentage:</b></Box>
                            <Box style={{ width: '100%' }} className='secondary'>{serverRole.serverRole.StoragePercentage}</Box>
                        </Box>
                        <Box direction="row">
                            <Box style={{ width: '100%' }} className='secondary'><b>CPU Model:</b></Box>
                            <Box style={{ width: '100%' }} className='secondary'>{serverRole.serverRole.CPUModel}</Box>
                        </Box>
                    </Box> : '')
            )
        }
        {
            roleServers.map(sol =>
                sol.SolutionPreview.roles.serverRoles.map(serverRole =>
                    serverRole.serverRole.roleName === 'Development System' ? DevSysContent = <Box Pad={{ between: "small" }} style={{ width: '100%' }}>
                        <Box direction="row" style={{ borderBottom: '1px solid rgba(0,0,0,.15)' }}>
                            <Box style={{ width: '100%', marginLeft: '25%' }}>
                                <span style={{ width: '100%', fontWeight: '600', margin: '10px 0' }}>{serverRole.serverRole.roleName}</span>
                            </Box>
                        </Box>
                        <Box direction="row">
                            <Box style={{ width: '100%' }} className='secondary'><b>Server:</b></Box>
                            <Box style={{ width: '100%' }} className='secondary'>{serverRole.serverRole.server}</Box>
                        </Box>
                        <Box direction="row">
                            <Box style={{ width: '100%' }} className='secondary'><b>CPU Percentage:</b></Box>
                            <Box style={{ width: '100%' }} className='secondary'>{serverRole.serverRole.CPUPercentage}</Box>
                        </Box>
                        <Box direction="row">
                            <Box style={{ width: '100%' }} className='secondary'><b>Storage Percentage:</b></Box>
                            <Box style={{ width: '100%' }} className='secondary'>{serverRole.serverRole.StoragePercentage}</Box>
                        </Box>
                        <Box direction="row">
                            <Box style={{ width: '100%' }} className='secondary'><b>CPU Model:</b></Box>
                            <Box style={{ width: '100%' }} className='secondary'>{serverRole.serverRole.CPUModel}</Box>
                        </Box>
                    </Box> : '')
            )
        }
        {
            roleServers.map(sol =>
                sol.SolutionPreview.roles.serverRoles.map(serverRole =>
                    serverRole.serverRole.roleName === 'Sandbox System' ? SandBoxContent = <Box Pad={{ between: "small" }} style={{ width: '100%' }}>
                        <Box direction="row" style={{ borderBottom: '1px solid rgba(0,0,0,.15)' }}>
                            <Box style={{ width: '100%', marginLeft: '25%' }}>
                                <span style={{ width: '100%', fontWeight: '600', margin: '10px 0' }}>{serverRole.serverRole.roleName}</span>
                            </Box>
                        </Box>
                        <Box direction="row">
                            <Box style={{ width: '100%' }} className='secondary'><b>Server:</b></Box>
                            <Box style={{ width: '100%' }} className='secondary'>{serverRole.serverRole.server}</Box>
                        </Box>
                        <Box direction="row">
                            <Box style={{ width: '100%' }} className='secondary'><b>CPU Percentage:</b></Box>
                            <Box style={{ width: '100%' }} className='secondary'>{serverRole.serverRole.CPUPercentage}</Box>
                        </Box>
                        <Box direction="row">
                            <Box style={{ width: '100%' }} className='secondary'><b>Storage Percentage:</b></Box>
                            <Box style={{ width: '100%' }} className='secondary'>{serverRole.serverRole.StoragePercentage}</Box>
                        </Box>
                        <Box direction="row">
                            <Box style={{ width: '100%' }} className='secondary'><b>CPU Model:</b></Box>
                            <Box style={{ width: '100%' }} className='secondary'>{serverRole.serverRole.CPUModel}</Box>
                        </Box>
                    </Box> : '')
            )
        }
        roleServers[0].SolutionPreview.roles.serverRoles.forEach(element => {
            labelsTobeBold.push(element.serverRole.roleName)
        });
        return (
            [ProdCentralServerContent, TestQASysContent, TrainingSystem, DevSysContent, SandBoxContent]
        )
    }
    render() {
        var host = this.renderSAPSolPreview();

        return (
            <Box id={ID_SOLUTION_PREVIEW}>
                <List style={{ width: '100%' }}>
                    <ListItem direction="column" separator='horizontal'>
                        <span separator='horizontal' style={{ fontWeight: '600', textAlign: 'center' }}>Recommended</span>
                        {host}
                    </ListItem>
                </List>
            </Box>
        );
    }

}

class SolutionPreviewSAPHANA extends Component {
    constructor() {
        super();
    }
    renderSAPHANASolPreview = () => {
        var ProdCentralServerContent;
        var TestQASysContent;
        var TrainingSystem;
        var DevSysContent;
        var SandBoxContent;
        var roleServers;

        if (this.props.SAPHANASolPreview && !Array.isArray(this.props.SAPHANASolPreview)) {
            roleServers = [this.props.SAPHANASolPreview];
        }
        if (roleServers === undefined) {
            return '';
        }
        roleServers[0].SolutionPreview.roles.serverRoles.forEach(element => {
            labelsTobeBold.push(element.serverRole.roleName)
        });
        return (
            roleServers.map(solpre =>
                solpre.SolutionPreview.roles.serverRoles.map(serverRole =>
                    // serverRole.serverRole.roleName === 'Production Environment' ? ProdCentralServerContent = 

                    <Box Pad={{ between: "small" }} style={{ width: '100%' }} >
                        <Box direction="row">
                            <span separator='horizontal' style={{ width: '100%', fontWeight: '600', textAlign: 'center', borderBottom: '1px solid rgba(0,0,0,.15)', margin: '10px 0' }}>{serverRole.serverRole.roleName}</span>
                            {/* <Box style={{ width: '100%', fontWeight: '600', textAlign: 'center' }} className='secondary'>{serverRole.serverRole.roleName}</Box> */}
                        </Box>
                        <Box direction="row">
                            <Box style={{ width: '100%' }} className='secondary'><b>Server :</b></Box>
                            <Box style={{ width: '100%' }} className='secondary'>{serverRole.serverRole.serverPlatform}</Box>
                        </Box>
                        <Box direction="row">
                            <Box style={{ width: '100%' }} className='secondary'><b>Processor Quantity :</b></Box>
                            <Box style={{ width: '100%' }} className='secondary'>{serverRole.serverRole.processorQuantity}</Box>
                        </Box>
                        <Box direction="row">
                            <Box style={{ width: '100%' }} className='secondary'><b>Processor Model :</b></Box>
                            <Box style={{ width: '100%' }} className='secondary'>{serverRole.serverRole.processorList}</Box>
                        </Box>
                        <Box direction="row">
                            <Box style={{ width: '100%' }} className='secondary'><b>Processor Family :</b></Box>
                            <Box style={{ width: '100%' }} className='secondary'>{serverRole.serverRole.processorFamily}</Box>
                        </Box>
                        <Box direction="row">
                            <Box style={{ width: '100%' }} className='secondary'><b>Memory (GB) :</b></Box>
                            <Box style={{ width: '100%' }} className='secondary'>{serverRole.serverRole.memoryList}</Box>
                        </Box>
                    </Box>
                )
            )
        )
    }
    render() {
        var host = this.renderSAPHANASolPreview();
        return (
            <Box id={ID_SOLUTION_PREVIEW}>
                <List style={{ width: '100%' }}>
                    <ListItem direction="column" separator='horizontal'>
                        <span separator='horizontal' style={{ fontWeight: '600', textAlign: 'center' }}>Recommended</span>
                        {host}
                    </ListItem>
                </List>
            </Box>
        );
    }

}

class SolutionPreviewSAPTDI extends Component {
    constructor() {
        super();
    }
    renderSAPTDISolPreview = () => {
        var ProdCentralServerContent;
        var TestQASysContent;
        var TrainingSystem;
        var DevSysContent;
        var SandBoxContent;
        var roleServers;

        if (this.props.SAPTDISolPreview && !Array.isArray(this.props.SAPTDISolPreview)) {
            roleServers = [this.props.SAPTDISolPreview];
        }
        if (roleServers === undefined) {
            return '';
        }
        roleServers[0].SolutionPreview.roles.serverRoles.forEach(element => {
            labelsTobeBold.push(element.serverRole.roleName)
        });
        return (
            roleServers.map(solpre =>
                solpre.SolutionPreview.roles.serverRoles.map(serverRole =>
                    <Box Pad={{ between: "small" }} style={{ width: '100%' }} >
                        <Box direction="row">
                            <span separator='horizontal' style={{ width: '100%', fontWeight: '600', textAlign: 'center', borderBottom: '1px solid rgba(0,0,0,.15)', margin: '10px 0' }}>{serverRole.serverRole.roleName}</span>
                            {/* <Box style={{ width: '100%', fontWeight: '600', textAlign: 'center' }} className='secondary'>{serverRole.serverRole.roleName}</Box> */}
                        </Box>
                        <Box direction="row">
                            <Box style={{ width: '100%' }} className='secondary'><b>Server :</b></Box>
                            <Box style={{ width: '100%' }} className='secondary'>{serverRole.serverRole.serverPlatform}</Box>
                        </Box>
                        <Box direction="row">
                            <Box style={{ width: '100%' }} className='secondary'><b>Processor Quantity :</b></Box>
                            <Box style={{ width: '100%' }} className='secondary'>{serverRole.serverRole.processorQuantity}</Box>
                        </Box>
                        <Box direction="row">
                            <Box style={{ width: '100%' }} className='secondary'><b>Processor Model :</b></Box>
                            <Box style={{ width: '100%' }} className='secondary'>{serverRole.serverRole.processorList}</Box>
                        </Box>
                        <Box direction="row">
                            <Box style={{ width: '100%' }} className='secondary'><b>Processor Family :</b></Box>
                            <Box style={{ width: '100%' }} className='secondary'>{serverRole.serverRole.processorFamily}</Box>
                        </Box>
                        <Box direction="row">
                            <Box style={{ width: '100%' }} className='secondary'><b>Memory (GB) :</b></Box>
                            <Box style={{ width: '100%' }} className='secondary'>{serverRole.serverRole.memoryList}</Box>
                        </Box>
                    </Box>
                )
            )
        )
    }
    render() {
        var host = this.renderSAPTDISolPreview();
        return (
            <Box id={ID_SOLUTION_PREVIEW}>
                <List style={{ width: '100%' }}>
                    <ListItem direction="column" separator='horizontal'>
                        <span separator='horizontal' style={{ fontWeight: '600', textAlign: 'center' }}>Recommended</span>
                        {host}
                    </ListItem>
                </List>
            </Box>
        );
    }

}

class SolutionPreview extends Component {
    constructor() {
        super();
        this.closeSolutionPreview = this.closeSolutionPreview.bind(this)
        this.createPreviewArray = this.createPreviewArray.bind(this)
    }

    componentDidMount() {
        if (this.props.isFromExternalApp) {
            getSSETData = true;
        }
        if (said === 'SAP') {
            let value = {
                "Workload": this.props.workload
            }
            var data = {
                Workload: value,
                name: ''
            }
            this.props.sapSolPreview(data);
        } else if (said === 'SAPHANA') {
            var data = {
                Workload: this.props.workload
            }
            if (this.props.workload.UserInputs.Environments.WorkloadType === 'SAPHANA') {
                this.props.sapHanaSolPreview(data);
            } else {
                this.props.sapTdiSolPreview(data);
            }
        }
    }
    componentWillReceiveProps(nextProps) {
        if (!this.props.UserInputs) {
            if (this.props.isFromExternalApp) {
                let queryParameter = queryString.parse(window.location.search);
                let userData = {
                    "reference": queryParameter.reference,
                    "isSizerAsEntry": queryParameter.isSizerAsEntry ? true : false
                };
                if (nextProps.sessionDefaults.workload && getSSETData) {
                    getSSETData = false;
                    this.props.getSSETData(userData);
                }
            }
            if (nextProps.activeSession && nextProps.activeSession.workload) {
                let obj = "";
                if (said === 'CS750VirtSizer' || said === 'SynergySizer') {
                    obj = {
                        "Workload": nextProps.activeSession.workload
                    }
                }
                else {
                    obj = nextProps.activeSession.workload;
                }
                if (nextProps.activeSession.workload.UserInputs.SizerMode !== commonConstants.GPELEMENT)
                    this.props.onNewSession(obj);
            }
        }
    }
    closeSolutionPreview() {
        this.props.onClose();
    }
    redirectUrl() {
        console.log('redirecting to SSET');
        window.location.replace(this.props.externalAppProps.ssetUrl);
    }
    createPreviewArray(splitTitle) {
        let solArr = [];
        var nextString = '';
        for (var i = 0; i < splitTitle.length; i++) {
            if (splitTitle[i] === nextString)
                continue;

            if (splitTitle[i] === commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.SERVER || splitTitle[i] === commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.PROCESSOR || splitTitle[i] === commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.MEMORY
                || splitTitle[i] === commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.NUMSERVER || splitTitle[i] === commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.PROCMODEL || splitTitle[i] === commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.REQRAM
                || splitTitle[i] === commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.LOCALBOOTDRIVECOUNT || splitTitle[i] === commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.LOCALBOOTDRIVETYPE || splitTitle[i] === commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.STORAGETYPE
                || splitTitle[i] === commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.VOLNAME || splitTitle[i] === commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.DISK || splitTitle[i] === commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.DISKQTY || splitTitle[i] === commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.CONTROLLER
                || splitTitle[i] === commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.CAPACITIES || splitTitle[i] === commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.CACHES || splitTitle[i] === commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.NETWORKING || splitTitle[i] === commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.CAPACITY
                || splitTitle[i] === commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.CACHE || splitTitle[i] === commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.FRAMENAME || splitTitle[i] === commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.DISKTYPE || splitTitle[i] === commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.ARRAYMODEL
                || splitTitle[i] === commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.LUNTYPE || splitTitle[i] === commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.RAIDLEVEL || splitTitle[i] === commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.MODULE) {
                nextString = splitTitle[i + 1];
                solArr.push(splitTitle[i] + ' ' + splitTitle[i + 1]);
            }
            else
                solArr.push(splitTitle[i]);
        }
        return solArr;

    }

    createPreviewArrayForSAP(splitTitle) {
        let solArr = [];
        var nextString = '';
        for (var i = 0; i < splitTitle.length; i++) {
            if (splitTitle[i] === nextString)
                continue;

            if (splitTitle[i] === commonConstants.SAPSOLUTIONPREVIEWVARIABLES.SERVER || splitTitle[i] === commonConstants.SAPSOLUTIONPREVIEWVARIABLES.PROCESSOR_QUANTITY || splitTitle[i] === commonConstants.SAPSOLUTIONPREVIEWVARIABLES.PROCESSOR_MODEL
                || splitTitle[i] === commonConstants.SAPSOLUTIONPREVIEWVARIABLES.PROCESSOR_FAMILY || splitTitle[i] === commonConstants.SAPSOLUTIONPREVIEWVARIABLES.MEMORY || splitTitle[i] === commonConstants.SAPSOLUTIONPREVIEWVARIABLES.CPU_MODEL || splitTitle[i] === commonConstants.SAPSOLUTIONPREVIEWVARIABLES.SAPS || splitTitle[i] === commonConstants.SAPSOLUTIONPREVIEWVARIABLES.DATABASE_SIZE || splitTitle[i] === commonConstants.SAPSOLUTIONPREVIEWVARIABLES.CONFIG_TYPE || splitTitle[i] === commonConstants.SAPSOLUTIONPREVIEWVARIABLES.DB_SERVER_CPU_CAPACITY || splitTitle[i] === commonConstants.SAPSOLUTIONPREVIEWVARIABLES.DATABSE_TYPE || splitTitle[i] === commonConstants.SAPSOLUTIONPREVIEWVARIABLES.OPERATING_SYSTEM || splitTitle[i] === commonConstants.SAPSOLUTIONPREVIEWVARIABLES.CPU_PERCENTAGE || splitTitle[i] === commonConstants.SAPSOLUTIONPREVIEWVARIABLES.STORAGE_PERCENTAGE) {
                nextString = splitTitle[i + 1];
                if (nextString.indexOf(':') > -1) {
                    nextString = '';
                    solArr.push(splitTitle[i] + ' ' + '');
                } else {
                    solArr.push(splitTitle[i] + ' ' + splitTitle[i + 1]);
                }
            }
            else
                solArr.push(splitTitle[i]);
        }
        return solArr;

    }
    DownloadasPDF() {
        let pdfName;
        if (this.props.isFromExternalApp) {
            pdfName = SOLUTION_PREVIEW;
        } else {
            if (this.props.activeSession) {
                pdfName = this.props.activeSession.alias;
            } else {
                pdfName = SOLUTION_PREVIEW;
            }
        }
        pdfName += " " + ((Date().substr(4)).split('GMT'))[0] + ".pdf";

        if (CS750SizerSaid.indexOf(said) > -1) {
            var strHTML = document.querySelector(`#${ID_SOLUTION_PREVIEW}`).innerText;
            var doc = new jsPDF();
            var splitTitle = doc.splitTextToSize(strHTML, 270);
            var arrPre = this.createPreviewArray(splitTitle);
            var pageWidth = doc.internal.pageSize.getWidth()
            doc.setFontType(commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.FONTTYPE_NORMAL);
            doc.setFontSize(commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.FONTSIZE_11);
            var y = 30;

            var HeaderImg = commonConstants.imageProperties.logoWithName;
            doc.addImage(HeaderImg, 'PNG', 10, 5, 30, 10);

            var FooterImg = commonConstants.imageProperties.logoUrl;

            for (var i = 0; i < arrPre.length; i++) {
                if (y > 280) {
                    y = 30;
                    doc.addPage();
                    doc.addImage(HeaderImg, 'PNG', 10, 5, 30, 10);
                }
                if (labelsTobeBold.indexOf(arrPre[i]) > -1) {
                    if (arrPre[i] === commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.RECOMMENDED) {
                        doc.setFontType(commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.FONTTYPE_NORMAL);
                        doc.setFontSize(commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.FONTSIZE_14);
                        doc.text(arrPre[i], (pageWidth / 2) - 20, y);
                    }
                    else if (arrPre[i] === commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.HOSTCONFIG || arrPre[i] === commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.STORAGECONFIG) {
                        doc.setFontType(commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.FONTTYPE_NORMAL);
                        doc.setFontSize(commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.FONTSIZE_14);
                        doc.text(arrPre[i], (pageWidth / 2) - 25, y);
                    }
                    else {
                        doc.setFontType(commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.FONTTYPE_BOLD);
                        doc.setFontSize(commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.FONTSIZE_12);
                        doc.text(arrPre[i], 15, y);
                    }
                }
                else {
                    doc.setFontType(commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.FONTTYPE_NORMAL);
                    doc.setFontSize(commonConstants.SYNERGYSOLUTIONPREVIEWVARIABLES.FONTSIZE_11);
                    doc.text(arrPre[i], 15, y);
                }
                doc.addImage(FooterImg, 'PNG', 0, 280, 40, 20);
                y = y + 7;
            }
            doc.save(pdfName);
            return;
        }
        else if (SAPSizerSaid.indexOf(said) > -1) {
            var strHTML = document.querySelector(`#${ID_SOLUTION_PREVIEW}`).innerText;
            var doc = new jsPDF();
            var splitTitle = doc.splitTextToSize(strHTML, 270);
            var arrPre = this.createPreviewArrayForSAP(splitTitle);
            var pageWidth = doc.internal.pageSize.getWidth()
            doc.setFontType(commonConstants.SAPSOLUTIONPREVIEWVARIABLES.FONTTYPE_NORMAL);
            doc.setFontSize(commonConstants.SAPSOLUTIONPREVIEWVARIABLES.FONTSIZE_11);
            var y = 30;

            var HeaderImg = commonConstants.imageProperties.logoWithName;
            doc.addImage(HeaderImg, 'PNG', 10, 5, 30, 10);

            var FooterImg = commonConstants.imageProperties.logoUrl;

            for (var i = 0; i < arrPre.length; i++) {
                if (y > 280) {
                    y = 30;
                    doc.addPage();
                    doc.addImage(HeaderImg, 'PNG', 10, 5, 30, 10);
                }
                if (labelsTobeBold.indexOf(arrPre[i]) > -1) {
                    if (arrPre[i] === commonConstants.SAPSOLUTIONPREVIEWVARIABLES.RECOMMENDED) {
                        doc.setFontType(commonConstants.SAPSOLUTIONPREVIEWVARIABLES.FONTTYPE_NORMAL);
                        doc.setFontSize(commonConstants.SAPSOLUTIONPREVIEWVARIABLES.FONTSIZE_14);
                        doc.text(arrPre[i], (pageWidth / 2) - 20, y);
                    }
                    else if (arrPre[i] === commonConstants.SAPSOLUTIONPREVIEWVARIABLES.ROLE_PRODUCITON_ENVIRONMENT || arrPre[i] === commonConstants.SAPSOLUTIONPREVIEWVARIABLES.ROLE_APPLICATION_ENVIRONMENT || arrPre[i] === commonConstants.SAPSOLUTIONPREVIEWVARIABLES.ROLE_PROD_CENTRAL_SERVER || arrPre[i] === commonConstants.SAPSOLUTIONPREVIEWVARIABLES.ROLE_TEST_ASSURANCE_SYSTEM || arrPre[i] === commonConstants.SAPSOLUTIONPREVIEWVARIABLES.ROLE_TRAINING_SYSTEM || arrPre[i] === commonConstants.SAPSOLUTIONPREVIEWVARIABLES.ROLE_DEVELOPMENT_SYSTEM || arrPre[i] === commonConstants.SAPSOLUTIONPREVIEWVARIABLES.ROLE_SANDBOX_SYSTEM) {
                        doc.setFontType(commonConstants.SAPSOLUTIONPREVIEWVARIABLES.FONTTYPE_BOLD);
                        doc.setFontSize(commonConstants.SAPSOLUTIONPREVIEWVARIABLES.FONTSIZE_12);
                        doc.text(arrPre[i], (pageWidth / 2) - 25, y);
                    }
                    else {
                        doc.setFontType(commonConstants.SAPSOLUTIONPREVIEWVARIABLES.FONTTYPE_BOLD);
                        doc.setFontSize(commonConstants.SAPSOLUTIONPREVIEWVARIABLES.FONTSIZE_12);
                        doc.text(arrPre[i], 15, y);
                    }
                }
                else {
                    doc.setFontType(commonConstants.SAPSOLUTIONPREVIEWVARIABLES.FONTTYPE_NORMAL);
                    doc.setFontSize(commonConstants.SAPSOLUTIONPREVIEWVARIABLES.FONTSIZE_11);
                    doc.text(arrPre[i], 15, y);
                }
                doc.addImage(FooterImg, 'PNG', 0, 280, 40, 20);
                y = y + 7;
            }
            doc.save(pdfName);
            return;
        }

        let value = {
            "Workload": this.props.workload
        }
        var data = {
            Workload: value,
            name: pdfName
        }
        this.props.onPDFExport(data);
    }

    render() {
        var content = '';
        let displayDownloadButton = false;
        if (said === 'EPAvNext' && this.props.workload && this.props.UserInputs) {
            if (this.props.workload.UserInputs.Environments.WorkloadType === 'BigData') {
                content = <SolutionPreviewBigData onClose={this.closeSolutionPreview} workload={this.props.workload} />
            } else if (this.props.workload.UserInputs.Environments.WorkloadType === 'BlueData') {
                content = <SolutionPreviewBlue isFromExternalApp={this.props.isFromExternalApp} onClose={this.closeSolutionPreview} workload={this.props.workload} />
                displayDownloadButton = true;
            }
        } else if (said === "SAP") {
            content = <SolutionPreviewSAP onClose={this.closeSolutionPreview} workload={this.props.workload} SAPSolPreview={this.props.SAPSolPreview} />
            displayDownloadButton = true;
        } else if (said === 'SAPHANA' && this.props.workload.UserInputs.Environments.WorkloadType === "SAPHANA") {
            content = <SolutionPreviewSAPHANA onClose={this.closeSolutionPreview} workload={this.props.workload} SAPHANASolPreview={this.props.SAPHANASolPreview} />
            displayDownloadButton = true;
        } else if (said === 'SAPHANA' && this.props.workload.UserInputs.Environments.WorkloadType === "TDI") {
            content = <SolutionPreviewSAPTDI onClose={this.closeSolutionPreview} workload={this.props.workload} SAPTDISolPreview={this.props.SAPTDISolPreview} />
            displayDownloadButton = true;
        }
        else if ((said === 'CS750VirtSizer' || said === 'SynergySizer') && this.props.workload && this.props.UserInputs) {
            content = <SolutionPreviewSynergy onClose={this.closeSolutionPreview} workload={this.props.workload} preview={this.props.SynergyPreview} />
            displayDownloadButton = true;
        }
        return (
            <Box style={{ height: '98%' }}>
                <Box colorIndex="light-2" direction="row" align='start' pad='none' separator="left"
                    style={{
                        height: '98%', width: '100%', overflowY: 'auto',
                        position: 'absolute', right: '0px', top: '0px', zIndex: 3
                    }}>

                    <Animate enter={{ "animation": "slide-left", "duration": 200, "delay": 0 }}
                        leave={{ "animation": "slide-left", "duration": 200, "delay": 0 }}
                        keep={true} style={{ width: '100%' }} >
                        <Box style={{ width: '100%' }}>
                            <Box direction='row' style={{ backgroundColor: '#28ab8c' }} >
                                <Box style={{ width: "95%", padding: '5px', color: '#fff' }} >
                                    <Heading tag="h4" align="center" margin="none" position='fixed' width='100%' strong={true} >Solution Preview</Heading>
                                </Box>
                                {this.props.isFromExternalApp ?
                                    <Button id="backToSSETyes" primary={false} plain={true} style={{ position: 'absolute', right: '0', color: 'white' }}  /* icon={<Revert size="small" colorIndex='accent-3' />} */ label='Close' onClick={() => { this.redirectUrl() }} className="ReverseSavewrkloadbtn" />
                                    :
                                    <Box id="informationiconbox" style={{ marginTop: "5px" }} direction="row" margin="none" pad="none" justify="end" onClick={() => this.props.onClose()} >
                                        <CloseIcon size='small' />
                                    </Box>
                                }
                            </Box>
                            <Box>
                                {content}
                            </Box>
                            {displayDownloadButton &&
                                <Box style={{ alignItems: 'center', padding: '10px' }}>
                                    <Button primary={false} label='Save as PDF' onClick={() => this.DownloadasPDF('pdf')} />
                                </Box>}
                        </Box>
                    </Animate>
                </Box>
            </Box>
        )
    }
}

const mapStateToProps = (state) => {
    let userInputs = undefined;
    let workload = undefined;
    if (state.sizerWorkload.workload !== undefined) {
        workload = state.sizerWorkload.workload;
        if (state.sizerWorkload.workload.Workload !== undefined)
            userInputs = state.sizerWorkload.workload.Workload.UserInputs;
        else
            userInputs = state.sizerWorkload.workload.UserInputs;
    }
    else if (state.sessions.activeSession.workload !== undefined) {
        workload = state.sessions.activeSession.workload;
        userInputs = state.sessions.activeSession.workload.UserInputs;
    }
    let _SynergyPreview = '';
    if (state.sizerWorkload.workload !== undefined && state.sizerWorkload.workload.Workload !== undefined && state.sizerWorkload.workload.Workload.UserInputs.SolutionPreview !== undefined)
        _SynergyPreview = state.sizerWorkload.workload.Workload.UserInputs.SolutionPreview;
    else if (state.sessions.activeSession.workload !== undefined && state.sessions.activeSession.workload.UserInputs !== undefined && state.sessions.activeSession.workload.UserInputs.SolutionPreview !== undefined)
        _SynergyPreview = state.sessions.activeSession.workload.UserInputs.SolutionPreview;

    return {
        //workload: state.sizerWorkload.workload,
        workload: workload,
        ServiceError: state.sizerWorkload,
        GPUdetailsforcore: state.sessions.activeSession,
        activeSession: state.sessions.activeSession,
        SSETid: state.sessions.SSETid,
        UserInputs: userInputs,
        //UserInputs: state.sizerWorkload.workload.UserInputs,
        sessionDefaults: state.sessions.sessionDefaults,
        stateObject: state,
        SynergyPreview: _SynergyPreview,
        SAPSolPreview: state.sessions.SAPSolPreview,
        SAPHANASolPreview: state.sessions.SAPHANASolPreview,
        SAPTDISolPreview: state.sessions.SAPTDISolPreview
    }
};
const mapDispatchToProps = (dispatch) => {
    return {
        sapSolPreview: (workload) => {
            dispatch(sapSolPreview(workload))
        },
        sapHanaSolPreview: (workload) => {
            dispatch(sapHanaSolPreview(workload))
        },
        sapTdiSolPreview: (workload) => {
            dispatch(sapTdiSolPreview(workload))
        },
        getSSETData: (userData) => { dispatch(loadSessionfromSSET(userData)) },
        onUpdateActiveSession: (workload) => {
            dispatch({ type: 'UPDATE_Active_WORKLOAD', payload: workload })
        },
        onNewSession: (workload) => {
            dispatch({ type: 'UPDATE_SIZER_WORKLOAD', payload: workload })
        },
        onPDFExport: (data) => {
            dispatch(downloadSolutionPreview(data))
        }
    }


};

export default connect(mapStateToProps, mapDispatchToProps)(SolutionPreview);





// WEBPACK FOOTER //
// ./src/SizingEngineUI/SizingEngineCommonScreens/SolutionPreview.js